<template>  
  <v-container fluid class="text-center">
    <v-row>
      <v-col v-show=" !fullMap && !halfMap ? true : false" :cols="(!fullMap || !halfMap)? showMap? window.width < 670?12:6 :12 :0" >
        <v-card class="flexcard" height="100%">
          <v-toolbar dense color="secondary" class="white--text">
            <v-btn fab v-if="itemsScenario[currentScenario].value=='ges' && limpiaSeleccionMapa" dark x-small color="success" @click="cancelSelectedRoute()" class="ml-0" title="limpia selección">
              <v-icon dark>
                mdi-cancel
              </v-icon>
            </v-btn>

            <v-btn fab v-if="itemsScenario[currentScenario].value=='optimorum' && limpiaSeleccionMapaOptimorum" dark x-small color="success" @click="cancelSelectedRouteOptimorum()" class="ml-0" title="limpia selección">
              <v-icon dark>
                mdi-cancel
              </v-icon>
            </v-btn>

            <v-btn fab v-if="itemsScenario[currentScenario].value=='ges' && getRoutes.length > 0" dark x-small color="#303030" @click="sendFilteredRoutesToMap()" class="ml-3" title="visualiza rutas en mapa ">
              <v-icon dark>
                mdi-map-marker
              </v-icon>
            </v-btn>

            <v-btn fab v-if="itemsScenario[currentScenario].value=='optimorum' && getRoutesOptimorum.length > 0" dark x-small color="#303030" @click="sendFilteredRoutesToMapOptimorum()" class="ml-3" title="visualiza rutas en mapa ">
              <v-icon dark>
                mdi-map-marker
              </v-icon>
            </v-btn>

            <v-btn fab v-if="itemsScenario[currentScenario].value=='ges' && routes.length>0" dark x-small color="#303030" @click="overlay = !overlay" class="ml-3" title="opciones de filtro">
              <v-icon dark>
                mdi-filter
              </v-icon>
            </v-btn>

            <v-btn fab v-if="itemsScenario[currentScenario].value=='optimorum' && routesOptimorum.length>0" dark x-small color="#303030" @click="overlayOptimorum = !overlayOptimorum" class="ml-3" title="opciones de filtro">
              <v-icon dark>
                mdi-filter
              </v-icon>
            </v-btn>

            <v-btn fab dark x-small color="#303030" @click="showMap=!showMap" class="ml-3" title="mostrar vista de mapa">
              <v-icon dark>
                mdi-map
              </v-icon>
            </v-btn>

            <v-btn fab dark v-if="itemsScenario[currentScenario].value=='ges' && routes.length>0" x-small color="#303030"  @click="displayFormat = (displayFormat=='resumen'?'tabla':'resumen')" class="ml-3" :title="displayFormat=='resumen'?'muestra tabla':'muestra resumen'">
              <v-icon v-if="displayFormat=='resumen'" dark>
                mdi-table-large
              </v-icon>
              <v-icon v-else dark>
                mdi-reorder-horizontal
              </v-icon>              
            </v-btn>

            <v-btn fab v-if="itemsScenario[currentScenario].value=='ges' && routes.length>0" dark x-small color="#303030" @click="makeResult()" class="ml-3" title="exporta a csv">
              <v-icon dark>
                mdi-microsoft-excel
              </v-icon>
            </v-btn>
            
            <v-btn fab dark x-small v-if="itemsScenario[currentScenario].value=='ges' && Object.keys(abastoMeses).length > 0" color="success" @click="months=!months" class="ml-0" title="Información de Hitos por Mes cargada">
              <v-icon dark>
                mdi-calendar
              </v-icon>
            </v-btn>

            <v-btn v-show="itemsScenario[currentScenario].value=='ges'" fab dark x-small class="ml-3 mr-3" color="#303030" title="carga información desde archivo">
              <v-file-input prepend-icon="mdi-upload" style="margin-top: -3px;margin-left: 8px;" hide-input truncate-length="15" dense outlined solo small-chips color="primary" v-model="file.id" show-size label="Seleccionar archivo..." :accept="mime_types" @change="loadFile()" :disabled="loading"></v-file-input>
            </v-btn>

            <v-btn v-show="itemsScenario[currentScenario].value=='optimorum'" fab dark x-small class="ml-3 mr-3" color="#303030" title="carga información desde archivo optimorum">
              <v-file-input prepend-icon="mdi-upload" style="margin-top: -3px;margin-left: 8px;" hide-input truncate-length="15" dense outlined solo small-chips color="primary" v-model="file.id" show-size label="Seleccionar archivo..." :accept="mime_types" @change="loadFileOptimorum()" :disabled="loading"></v-file-input>
            </v-btn>

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#0000fb"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  {{ itemsScenario.length>0?itemsScenario[currentScenario].text:'' }}
                </v-btn>
              </template>
              <v-list dense>
                <v-subheader>ESCENARIOS</v-subheader>
                <v-list-item-group
                  v-model="currentScenario"
                  color="primary"
                >
                  <v-list-item
                    v-for="(item, i) in itemsScenario"
                    :key="i"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>

            <v-btn v-show="itemsScenario[currentScenario].value=='optimorum'" @click="showOptimorumPlaneado=!showOptimorumPlaneado" tile dark small class="ml-3" :color="showOptimorumPlaneado?'#777':'#303030'" title="mapa planeado">
              planeado
            </v-btn>
            <v-btn v-show="itemsScenario[currentScenario].value=='optimorum'" @click="showOptimorumReal=!showOptimorumReal" tile dark small class="ml-3" :color="showOptimorumReal?'#777':'#303030'" title="mapa real">
              real
            </v-btn>

            <v-btn fab v-show="itemsScenario[currentScenario].value=='optimorum'" dark x-small :color="logError.length>0?'#FF6A00':'#303030'" @click="overlayLog = !overlayLog" class="ml-3" title="log de carga">
              <v-icon dark>
                mdi-note-text
              </v-icon>
            </v-btn>

            <v-btn fab v-show="itemsScenario[currentScenario].value=='optimorum'" dark x-small :color="noCostSegments.length>0?'#FF6A00':'#303030'" @click="overlayNoCostSegments = !overlayNoCostSegments" class="ml-3" title="listado de segmentos de ruta sin costo">
              <v-icon dark>
                mdi-currency-usd
              </v-icon>
            </v-btn>

            <v-btn fab v-show="itemsScenario[currentScenario].value=='optimorum'" dark x-small color="#303030" @click="overlayDetalleDP = !overlayDetalleDP" class="ml-3" title="listado de volumen por destino-producto">
              <v-icon dark>
                mdi-list-status
              </v-icon>
            </v-btn>

            <v-btn fab v-show="itemsScenario[currentScenario].value=='optimorum' && (routesOptimorum.length>0 || routesOptimorumReal.length>0)" dark x-small color="#303030" @click="makeResultOptimorum()" class="ml-3" title="exporta a csv">
              <v-icon dark>
                mdi-microsoft-excel
              </v-icon>
            </v-btn>

          </v-toolbar>
          <v-card-text>
            <div v-show="itemsScenario[currentScenario].value=='ges' && displayFormat=='resumen'" :style="'overflow-y:auto;max-height:'+(window.height)+'px;'">
              <div v-if="Object.keys(selectedRoute).length>0" style="width:100%;display: flex;justify-content: center;align-items: center; ">
                <div v-if="selectedRoute.planta != ''" style="max-width:50ch;">
                  <h3 v-if="cb[selectedRoute.idOrigen] && cb[selectedRoute.idDestino]" class="subtitle" >
                    De {{ selectedRoute.idOrigen }} {{ cb[selectedRoute.idOrigen]?cb[selectedRoute.idOrigen].descripcion:selectedRoute.idOrigen }} a {{ selectedRoute.idDestino }} {{ cb[selectedRoute.idDestino]?cb[selectedRoute.idDestino].descripcion:selectedRoute.idDestino }}<div>[{{ selectedRoute.producto }}]</div>
                  </h3>
                  <template v-for="(element,i) in selectedRoute.cadena" >
                    <template v-if="plants[element]">
                      <div class="box planta" :key="'cadena'+i">
                        {{element}} {{ cb[element]? cb[element].descripcion: element }}
                        <div>Producción: ${{ plants[element] ?numberWithCommasND(plants[element].costo):0 }}
                        </div>                              
                      </div>                            
                    </template>
                    <div v-else class="box bodega" :key="'cadena'+i">
                      {{ selectedRoute.cadena[i] }} {{ cb[selectedRoute.cadena[i]]? cb[selectedRoute.cadena[i]].descripcion:selectedRoute.cadena[i] }}
                    </div>                         
                    <div v-if="i < selectedRoute.cadena.length-1" class="box tramo">
                      <v-icon>mdi-arrow-down</v-icon>                            
                        <div v-if="i == selectedRoute.cadena.length-2">{{ selectedRoute.producto }}</div>                            
                        <div v-else>{{ selectedRoute.cadenaProducto[i] }}</div>
                        <div>{{ selectedRoute.cadenaTransporte[i] }}</div>
                      <div>Flete: ${{ numberWithCommasND(Math.round((selectedRoute.cadenaCostoTramo[i])*100)/100) }}</div>
                      <div>Flete Acum: ${{ numberWithCommasND(Math.round((selectedRoute.cadenaAcumCosto[i])*100)/100) }}</div>
                      <div>Volumen: {{ numberWithCommasND(Math.round((selectedRoute.cadenaVolumen[i])*100)/100) }} Tn.</div>
                      <div>Volumen Tramo: {{ numberWithCommasND(Math.round((selectedRoute.cadenaVolumenTramo[i])*100)/100) }} Tn.</div>
                      
                      <v-icon>mdi-arrow-down</v-icon>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="titleTablesOp" v-if="itemsScenario[currentScenario].value=='optimorum' && showOptimorumReal && showOptimorumPlaneado">PLANEADO</div>
            <div v-show="displayFormat!='resumen' && (itemsScenario[currentScenario].value=='ges' || (itemsScenario[currentScenario].value=='optimorum' && showOptimorumPlaneado))" :style="'background-color:#fff;overflow-y:auto;height:'+(showOptimorumReal && showOptimorumPlaneado? window.height/1.9-ajusteVentana : window.height-ajusteVentana)+'px;'">
              <table v-if="(this.routes.length > 0) && window.width >=670 && itemsScenario[currentScenario].value=='ges'">
                <thead>
                  <tr>
                    <th @click="setColumnSort('renglon')">#</th>
                    <th @click="setColumnSort('idOrigen')">Origen</th>
                    <th @click="setColumnSort('idDestino')">Destino</th>
                    <th @click="setColumnSort('producto')">Producto</th>
                    <th @click="setColumnSort('volumenTramo')">Tns</th>
                    <th @click="setColumnSort('planta')">Planta</th>
                    <th @click="setColumnSort('costoProduccion')" title="Costo Variable de Producción">$Prod</th>
                    <th @click="setColumnSort('costoTramo')" title="Costo Flete por Tonelada Segmento">$TnS</th>
                    <th @click="setColumnSort('costoRuta')" title="Costo Flete por Tonelada Encadenado">$TnE</th>
                    <th @click="setColumnSort('costoTotal')" title="Costo Total (Flete + Variable) por Tonelada Encadenado">$Int</th>
                    <!-- <th title="Costo Flete por Tonelada Kilómetro">$TonKm</th>
                    <th >Distancia</th> -->
                    <th @click="setColumnSort('transporteTramo')">Transporte</th>
                    <th @click="setColumnSort('vehiculoTramo')">Vehiculo</th>
                    <th @click="setColumnSort('saltos')">Saltos</th>                       
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in getRoutes" 
                      @click="setSelectedRoute(item,1)" 
                      :class="Object.keys(selectedRoute).length>0 && item.renglon==selectedRoute.renglon?'selected':''"
                  >
                    <td>{{ item.renglon }}</td>                    
                    <td class="text-left" :title="cb[item.idOrigen]? item.idOrigen+' '+cb[item.idOrigen].descripcion:item.idOrigen">
                      {{ cb[item.idOrigen]?cb[item.idOrigen].descripcion:item.idOrigen }}
                    </td>
                    <td class="text-left" :title="cb[item.idDestino]? item.idDestino+' '+cb[item.idDestino].descripcion:item.idDestino">
                      {{ cb[item.idDestino]?cb[item.idDestino].descripcion:item.idDestino }}
                    </td>
                    <td>{{ item.producto }}</td>
                    <td>{{ numberWithCommasND(item.volumenTramo) }}</td>
                    <td :title="cb[item.planta]?item.planta+' '+cb[item.planta].descripcion:''">
                      {{ item.planta != '' && cb[item.planta]? cb[item.planta].descripcion : '' }}
                    </td>
                    <td>{{ numberWithCommasND(item.costoProduccion) }}</td>
                    <td>{{ numberWithCommasND(item.costoTramo) }}</td>
                    <td>{{ numberWithCommasND(item.costoRuta) }}</td>
                    <td>{{ numberWithCommasND(item.costoProduccion*1 + item.costoRuta*1)  }}</td>
                    <!--<td>{{ numberWithCommasND(item.distancia) }}</td> -->                    
                    <td>{{ item.transporteTramo }}</td>
                    <td>{{ item.vehiculoTramo }}</td>
                    <td>{{ item.saltos }}</td>
                  </tr>
                </tbody>
              </table>
              <table v-if="(this.routesOptimorum.length > 0) && window.width >=670 && itemsScenario[currentScenario].value=='optimorum'">
                <thead>
                  <tr>
                    <th @click="setColumnSortOptimorum('renglon')">#</th>
                    <th @click="setColumnSortOptimorum('renglon')">KeyId</th>
                    <th @click="setColumnSortOptimorum('idOrigen')">Origen</th>
                    <th @click="setColumnSortOptimorum('idDestino')">Destino</th>
                    <th @click="setColumnSortOptimorum('producto')">Producto</th>
                    <th @click="setColumnSortOptimorum('volumenTramo')">Tns</th>
                    <th @click="setColumnSortOptimorum('planta')">Planta</th>
                    <th @click="setColumnSortOptimorum('costoProduccion')" title="Costo Variable de Producción">$Prod</th>
                    <th @click="setColumnSortOptimorum('costoTramo')" title="Costo Flete por Tonelada Segmento">$TnS</th>
                    <th @click="setColumnSortOptimorum('costoRuta')" title="Costo Flete por Tonelada Encadenado">$TnE</th>
                    <th @click="setColumnSortOptimorum('costoTotal')" title="Costo Total (Flete + Variable) por Tonelada Encadenado">$Int</th>
                    <th @click="setColumnSortOptimorum('costoMejor')" title="Mejor costo en ruta">$TnM</th>
                    <th @click="setColumnSortOptimorum('ahorroPot')" title="Ahorro potencial">$APot</th>
                    <th @click="setColumnSortOptimorum('costoMejorPlan')" title="Mejor costo en ruta plan">$TnMP</th>
                    <th @click="setColumnSortOptimorum('ahorroPotPlan')" title="Ahorro potencial plan">$APotP</th>
                    <!-- <th title="Costo Flete por Tonelada Kilómetro">$TonKm</th>
                    <th >Distancia</th> -->
                    <th @click="setColumnSortOptimorum('desProd')">DesProd</th>
                    <th @click="setColumnSortOptimorum('odpt')">ODPT</th>
                    <th @click="setColumnSortOptimorum('interfacility_chain')">Cadena</th>                    
                    <th @click="setColumnSortOptimorum('saltos')">Saltos</th>
                  </tr>
                </thead>                
                <tbody>
                  <tr v-for="(item,index) in getRoutesOptimorum" 
                      @click="setSelectedRouteOptimorum(item,1)" 
                      :class="Object.keys(selectedRouteOptimorum).length>0 && item.renglon==selectedRouteOptimorum.renglon?'selected':''"
                  >
                    <td>{{ item.renglon }}</td>
                    <td>{{ item.keyId }}</td>
                    <td class="text-left" :title="cbOptimorum[item.idOrigen]? item.idOrigen+' '+cbOptimorum[item.idOrigen].descripcion:item.idOrigen">
                      {{ cbOptimorum[item.idOrigen]?cbOptimorum[item.idOrigen].descripcion:item.idOrigen }}
                    </td>
                    <td class="text-left" :title="cbOptimorum[item.idDestino]? item.idDestino+' '+cbOptimorum[item.idDestino].descripcion:item.idDestino">
                      {{ cbOptimorum[item.idDestino]?cbOptimorum[item.idDestino].descripcion:item.idDestino }}
                    </td>
                    <td>{{ item.producto }}</td>
                    <td>{{ numberWithCommasND(item.volumenTramo) }}</td>
                    <td :title="cbOptimorum[item.planta]?item.planta+' '+cbOptimorum[item.planta].descripcion:''">
                      {{ item.planta != '' && cbOptimorum[item.planta]? cbOptimorum[item.planta].descripcion : '' }}
                    </td>
                    <td>{{ numberWithCommasND(item.costoProduccion) }}</td>
                    <td :class="item.bCostoCalculado?'calculated':''" :title="item.bCostoCalculado?'Contiene en la ruta segmentos calculados':''">{{ numberWithCommasND(item.costoTramo) }}</td>
                    <td :class="item.bCostoCalculado?'calculated':''" :title="item.bCostoCalculado?'Contiene en la ruta segmentos calculados':''">{{ numberWithCommasND(item.costoRuta) }}</td>
                    <td :class="item.bCostoCalculado?'calculated':''" :title="item.bCostoCalculado?'Contiene en la ruta segmentos calculados':''">{{ numberWithCommasND(item.costoTotal)  }}</td>
                    <td>{{ numberWithCommasND(item.costoMejor) }}</td>
                    <td>{{ numberWithCommasND(item.ahorroPot) }}</td>
                    <td>{{ numberWithCommasND(item.costoMejorPlan) }}</td>
                    <td>{{ numberWithCommasND(item.ahorroPotPlan) }}</td>
                    <!-- <td>{{ numberWithCommas(item.costoTramoKm) }}</td>
                    <td>{{ numberWithCommasND(item.distancia) }}</td> -->
                    <td>{{ item.desProd }}</td>
                    <td>{{ item.odpt }}</td>
                    <td>{{ item.interfacility_chain }}</td>                    
                    <td>{{ item.saltos }}</td>
                  </tr>
                </tbody>
              </table>
              
              <!-- resolución mejor a 670px cambia de formato a movil -->
              <!-- <div v-if="this.routes.length > 0 && window.width < 670 ">
                <div style="color:#000;border:1px solid #eee; " v-for="(item,index) in getRoutes" 
                  @click="setSelectedRoute(item, 1)"
                  :class="Object.keys(selectedRoute).length>0 && item.renglon == selectedRoute.renglon?'selected':''"
                >                  
                  <div style="font-weight:500;width:100%;display:flex;align-content:center;text-align:center;">
                    <div style="align-self:center;" class="ml-2 mr-3 text-center">{{item.renglon}}</div>
                    <div style="align-self:center;width:100%;" class="mr-1 text-center" :title="cb[item.idOrigen]? item.idOrigen+' '+cb[item.idOrigen].descripcion:''">
                      {{ cb[item.idOrigen]?cb[item.idOrigen].descripcion : item.idOrigen }}
                    </div>                    
                    <div style="align-self:center;width:100%;" class="ml-1 text-center" :title="cb[item.idDestino]? item.idDestino+' '+cb[item.idDestino].descripcion:''">
                      {{ cb[item.idDestino]?cb[item.idDestino].descripcion : item.idDestino }}
                    </div>                    
                  </div>
                  
                  <div style="align-self:center;" class="mr-0">{{ item.producto }}</div>
                  <div>{{ item.volumen }}Tn.</div>

                  <div :title="item.planta != '' && cb[item.planta]? cb[item.planta].descripcion : ''">
                    {{ item.planta != '' && cb[item.planta]? cb[item.planta].descripcion : '' }} ${{ numberWithCommasND(item.costoProduccion) }}
                  </div>                  
                  <div>{{ item.saltos }} Saltos</div>
                </div>
              </div> -->

            </div>
            <div v-if="routesOptimorum.length > 0 && showOptimorumPlaneado" class="footer-line">{{ getSummaryOptimorum.cantidad }} registros y {{ getLlavesUnicas('planeado').length }} rutas {{ numberWithCommasND(getSummaryOptimorum.volumen) }} tn. $TnS: {{ numberWithCommasND(getSummaryOptimorum.costoTnSeg) }}, $TnE: {{ numberWithCommasND(getSummaryOptimorum.costoTn) }}, $Prod: {{ numberWithCommasND(getSummaryOptimorum.costoTnProd) }}, $Int: {{ numberWithCommasND(getSummaryOptimorum.integral)}}, $APot: {{numberWithCommasND(getSummaryOptimorum.ahorroPot)}}, $APotP: {{ numberWithCommasND(getSummaryOptimorum.ahorroPotPlan) }}</div>
            <div v-if="routesOptimorum.length > 0 && !showOptimorumReal" class="footer-line footer-end" >
              <div style="align-self:center; max-width: 100%; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" >
                {{ fileUploadedOptimorum }}
              </div>
            </div>

            <div class="titleTablesOp" v-if="itemsScenario[currentScenario].value=='optimorum' && showOptimorumReal && showOptimorumPlaneado">REAL</div>
            <div v-show="displayFormat!='resumen' && itemsScenario[currentScenario].value=='optimorum' && showOptimorumReal" :style="'background-color:#fff;overflow-y:auto;height:'+(showOptimorumReal && showOptimorumPlaneado? window.height/1.9-ajusteVentana : window.height-ajusteVentana)+'px;'">
              <table v-if="(this.routes.length > 0 || this.routesOptimorumReal.length > 0) && window.width >=670 ">
                <thead>
                  <tr>
                    <th @click="setColumnSortOptimorumReal('renglon')">#</th>
                    <th @click="setColumnSortOptimorumReal('renglon')">KeyId</th>
                    <th @click="setColumnSortOptimorumReal('idOrigen')">Origen</th>
                    <th @click="setColumnSortOptimorumReal('idDestino')">Destino</th>
                    <th @click="setColumnSortOptimorumReal('producto')">Producto</th>
                    <th @click="setColumnSortOptimorumReal('volumenTramo')">Tns</th>
                    <th @click="setColumnSortOptimorumReal('planta')">Planta</th>
                    <th @click="setColumnSortOptimorumReal('costoProduccion')" title="Costo Variable de Producción">$Prod</th>
                    <th @click="setColumnSortOptimorumReal('costoTramo')" title="Costo Flete por Tonelada Segmento">$TnS</th>
                    <th @click="setColumnSortOptimorumReal('costoRuta')" title="Costo Flete por Tonelada Encadenado">$TnE</th>
                    <th @click="setColumnSortOptimorumReal('costoTotal')" title="Costo Total (Flete + Variable) por Tonelada Encadenado">$Int</th>
                    <th @click="setColumnSortOptimorumReal('costoMejor')" title="'Mejor costo en ruta'">$TnM</th>
                    <th @click="setColumnSortOptimorumReal('ahorroPot')" title="'Ahorro potencial'">$APot</th>
                    <th @click="setColumnSortOptimorumReal('costoMejorPlan')" title="Mejor costo en ruta plan">$TnMP</th>
                    <th @click="setColumnSortOptimorumReal('ahorroPotPlan')" title="Ahorro potencial plan">$APotP</th>
                    <!-- <th title="Costo Flete por Tonelada Kilómetro">$TonKm</th>
                    <th >Distancia</th> -->
                    <th @click="setColumnSortOptimorumReal('desProd')">DesProd</th>
                    <th @click="setColumnSortOptimorumReal('odpt')">ODPT</th>
                    <th @click="setColumnSortOptimorumReal('interfacility_chain')">Cadena</th>                    
                    <th @click="setColumnSortOptimorumReal('saltos')">Saltos</th>                       
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in getRoutesOptimorumReal" 
                      @click="setSelectedRouteOptimorumReal(item,1)" 
                      :class="Object.keys(selectedRouteOptimorumReal).length>0 && item.renglon==selectedRouteOptimorumReal.renglon?'selected':''"
                  >
                    <td>{{ item.renglon }}</td>
                    <td>{{ item.keyId }}</td>
                    <td class="text-left" :title="cbOptimorum[item.idOrigen]? item.idOrigen+' '+cbOptimorum[item.idOrigen].descripcion:item.idOrigen">
                      {{ cbOptimorum[item.idOrigen]?cbOptimorum[item.idOrigen].descripcion:item.idOrigen }}
                    </td>
                    <td class="text-left" :title="cbOptimorum[item.idDestino]? item.idDestino+' '+cbOptimorum[item.idDestino].descripcion:item.idDestino">
                      {{ cbOptimorum[item.idDestino]?cbOptimorum[item.idDestino].descripcion:item.idDestino }}
                    </td>
                    <td>{{ item.producto }}</td>
                    <td>{{ numberWithCommasND(item.volumenTramo) }}</td>
                    <td :title="cbOptimorum[item.planta]?item.planta+' '+cbOptimorum[item.planta].descripcion:''">
                      {{ item.planta != '' && cbOptimorum[item.planta]? cbOptimorum[item.planta].descripcion : '' }}
                    </td>
                    <td>{{ numberWithCommasND(item.costoProduccion) }}</td>
                    <td :class="item.bCostoCalculado?'calculated':''" :title="item.bCostoCalculado?'Contiene en la ruta segmentos calculados':''">{{ numberWithCommasND(item.costoTramo) }}</td>
                    <td :class="item.bCostoCalculado?'calculated':''" :title="item.bCostoCalculado?'Contiene en la ruta segmentos calculados':''">{{ numberWithCommasND(item.costoRuta) }}</td>
                    <td :class="item.bCostoCalculado?'calculated':''" :title="item.bCostoCalculado?'Contiene en la ruta segmentos calculados':''">{{ numberWithCommasND(item.costoTotal)  }}</td>
                    <td>{{ numberWithCommasND(item.costoMejor) }}</td>
                    <td>{{ numberWithCommasND(item.ahorroPot) }}</td>
                    <td>{{ numberWithCommasND(item.costoMejorPlan) }}</td>
                    <td>{{ numberWithCommasND(item.ahorroPotPlan) }}</td>
                    <!-- <td>{{ numberWithCommas(item.costoTramoKm) }}</td>
                    <td>{{ numberWithCommasND(item.distancia) }}</td> -->
                    <td>{{ item.desProd }}</td>
                    <td>{{ item.odpt }}</td>
                    <td>{{ item.interfacility_chain }}</td> <!-- transporteTramo -->                    
                    <td>{{ item.saltos }}</td>
                  </tr>
                </tbody>
              </table>              
            </div>
            <div v-if="routesOptimorumReal.length > 0 && showOptimorumReal" class="footer-line">{{ getSummaryOptimorumReal.cantidad }} registros y {{ getLlavesUnicas('real').length }} rutas {{ numberWithCommasND(getSummaryOptimorumReal.volumen) }} tn. $TnS: {{ numberWithCommasND(getSummaryOptimorumReal.costoTnSeg) }}, $TnE: {{ numberWithCommasND(getSummaryOptimorumReal.costoTn) }}, $Prod: {{ numberWithCommasND(getSummaryOptimorumReal.costoTnProd) }}, $Int: {{ numberWithCommasND(getSummaryOptimorumReal.integral)}}, $APot: {{numberWithCommasND(getSummaryOptimorumReal.ahorroPot) }}, $AEjec:{{ numberWithCommasND((getSummaryOptimorum.integral - getSummaryOptimorumReal.integral) * getSummaryOptimorumReal.volumen) }}</div>
            <div v-if="routesOptimorumReal.length > 0 && showOptimorumReal" class="footer-line footer-end" >
              <div style="align-self:center; max-width: 100%; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" >
                {{ fileUploadedOptimorum }}
              </div>
            </div>
          </v-card-text>
          <v-card-actions v-show="displayFormat!='resumen'">
            <v-col v-if="itemsScenario[currentScenario].value=='ges'" cols=12>
              <div v-if="routes.length > 0" class="footer-line">{{ getSummary.cantidad }} rutas {{ numberWithCommasND(getSummary.volumen) }} tn. $TnS: {{ numberWithCommasND(getSummary.costoTnSeg) }}, $TnE: {{ numberWithCommasND(getSummary.costoTn) }} y $Prod: {{ numberWithCommasND(getSummary.costoTnProd) }}</div>
              <div class="footer-line footer-end" >
                <div style="align-self:center; max-width: 100%; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" >
                  {{ fileUploaded }}
                </div>
              </div>
            </v-col>
            <!-- <v-col v-if="itemsScenario[currentScenario].value=='optimorum'" cols=12>
              <div v-if="routesOptimorum.length > 0" class="footer-line">{{ getSummaryOptimorum.cantidad }} registros y {{ getLlavesUnicas().length }} rutas visibles con {{ numberWithCommasND(getSummaryOptimorum.volumen) }} tn. $TnSeg: {{ numberWithCommasND(getSummaryOptimorum.costoTnSeg) }}, $Tn: {{ numberWithCommasND(getSummaryOptimorum.costoTn) }} $TnProd: {{ numberWithCommasND(getSummaryOptimorum.costoTnProd) }} e Integral: {{ numberWithCommasND(getSummaryOptimorum.integral) }}</div>
              <div class="footer-line footer-end" >
                <div style="align-self:center; max-width: 100%; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" >
                  {{ fileUploadedOptimorum }}
                </div>
              </div>
            </v-col> -->
          </v-card-actions>
        </v-card>
      </v-col>      
      <v-col v-show="itemsScenario[currentScenario].value=='ges' && (fullMap?true:showMap)" :cols="fullMap?12: window.width < 670?12:6">
        <div :class="'btn__mode selected'" @click="fullMap=!fullMap"></div>
        <mapa mapaNombre="ges" titleCard="" :plantas="marcadoresPlanta" :rutas="rutasABASTO" :abastoNOM="abastoNOM" :entregasNOM="entregasNOM" :poligonosNOM="poligonosNOM" :selectedRoute="selectedRoute" :cb="cb" :vehicle="vehicle" :ytdRoutes="ytdRoutes" :hideTableDetailTransport="false"
        :scenario="itemsScenario[currentScenario].value"
        ></mapa>
      </v-col>
      <v-col  v-show="itemsScenario[currentScenario].value=='optimorum' && (fullMap || halfMap?true:showMap) && showOptimorumPlaneado" :cols="fullMap?12: window.width < 670?12:halfMap?6:showOptimorumPlaneado & showOptimorumReal?3:showOptimorumPlaneado?6:0">
        <div :class="'btn__mode selected'" @click="fullMap=!fullMap"></div>
        <div v-show="showOptimorumPlaneado & showOptimorumReal" :class="'btn__mode__half '" style="background-color: #0000b3;" @click="halfMap=!halfMap"></div>
        <mapa mapaNombre="optimorumPlan" titleCard="Planeado" :plantas="marcadoresPlantaOptimorum" :rutas="rutasABASTOOptimorum" :abastoNOM="[]" :entregasNOM="[]" :poligonosNOM="[]" :selectedRoute="selectedRouteOptimorum" :cb="cbOptimorum" :vehicle="vehicleOptimorum" :ytdRoutes="[]" :hideTableDetailTransport="true" :scenario="itemsScenario[currentScenario].value"></mapa>
      </v-col>
      <v-col  v-show="itemsScenario[currentScenario].value=='optimorum' && (fullMap?true:showMap) && showOptimorumReal" :cols="fullMap?12: window.width < 670?12:halfMap?6:showOptimorumPlaneado & showOptimorumReal?3: showOptimorumReal?6:0">
        <div v-show="!showOptimorumPlaneado" :class="'btn__mode selected'" @click="fullMap=!fullMap"></div>
        <mapa mapaNombre="optimorumReal" titleCard="Real" :plantas="marcadoresPlantaOptimorum" :rutas="rutasABASTOOptimorumReal" :abastoNOM="[]" :entregasNOM="[]" :poligonosNOM="[]" :selectedRoute="selectedRouteOptimorumReal" :cb="cbOptimorum" :vehicle="vehicleOptimorum" :ytdRoutes="[]" :hideTableDetailTransport="true" :scenario="itemsScenario[currentScenario].value"></mapa>        
      </v-col>
    </v-row>

    <!-- loading -->
    <v-overlay absolute :value="loading" opacity="0.8">
      <div class="text-center">
        <v-progress-circular indeterminate size="60" color="primary" class="mb-5"></v-progress-circular>
        <p>Procesando...</p>
      </div>
    </v-overlay>

    <!-- months -->
    <v-overlay v-model="months" class="align-center justify-center" contained>
      <v-card light width="360" class="pa-3">
        <h3>Meses</h3>
        <v-card-text style="max-height:350px;overflow-y:auto;">
          <v-container >
            <v-row no-gutters>
              <v-col>
              ¿Cuál mes quieres procesar?
              </v-col>
            </v-row>
            <v-row no-gutters>            
              <v-col>
                <v-combobox v-model="mesActual" :items="itemsListMonths" clearable dense solo label="Meses"></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                  v-if="mesActual"
                  elevation="2"
                  small
                  class="ma-1"
                  @click="exportCosts()"
                >cat_costos</v-btn>
                <v-btn
                  v-if="mesActual"
                  elevation="2"
                  small
                  class="ma-1"
                  @click="exportCostsVehicle()"
                >cat_vehiculo</v-btn>
                <v-btn
                  v-if="mesActual"
                  elevation="2"
                  small
                  class="ma-1"
                  @click="exportYTDRoutes()"
                >ytd_rutas</v-btn>
                <v-btn
                  v-if="mesActual"
                  elevation="2"
                  small
                  class="ma-1"
                  @click="exportRelation()"
                >relation</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-btn color="#1565C0" @click="months = false" fab dark small absolute top right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-overlay>
    
    <!-- filtros -->
    <v-overlay v-model="overlay" class="align-center justify-center" contained>
      <v-card light width="360" class="pa-3">
        <h3>Filtros</h3>
        <v-card-text style="max-height:380px;overflow-y:auto;">
        <v-container >
          <!-- filtro de origen-->
          <v-row no-gutters>            
            <v-col>
                <v-combobox multiple v-model="idOrigen" :items="itemsList" clearable dense label="Origen" ></v-combobox>
          <!-- filtro de destino-->
                <v-combobox multiple v-model="idDestino" :items="itemsListDestino" clearable dense label="Destino" class="mt-1"></v-combobox>
          <!-- filtro de productos-->
                <v-combobox multiple v-model="producto" :items="itemsListProducto" clearable dense label="Producto"  class="mt-1"></v-combobox>
          <!-- filtro de saltos-->
                <v-text-field v-model="saltos" dense label="Número de saltos" clearable class="mt-1"></v-text-field>
          <!-- filtro de destino-->
              <v-combobox multiple v-model="idPlantaProd" :items="itemsListPlantaProd" clearable dense label="Planta Productora" class="mt-1"></v-combobox>
          <!-- filtro de destino-->
              <v-combobox multiple v-model="transportesFiltro" :items="itemsListTransporte" hide-details clearable dense label="Transporte" class="mt-1"></v-combobox>
            </v-col>
          </v-row>
          <!-- Filtro de costo tramo -->
          <v-row no-gutters v-show="false">
            <v-col>
              <div>Costo Segmento $MXN/Tn</div>
              <v-range-slider
                v-model="range"
                :max="max"
                :min="min"
                dense
                class="align-center"
              >
                <template v-slot:prepend>
                  <v-text-field
                    :value="range[0]"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    dense
                    style="width: 60px"
                    @change="$set(range, 0, $event)"
                  ></v-text-field>
                </template>
                <template v-slot:append>
                  <v-text-field
                    :value="range[1]"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    dense
                    type="number"
                    style="width: 60px"
                    @change="$set(range, 1, $event)"
                  ></v-text-field>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>
          <!-- Filtro de volumen -->
          <v-row no-gutters v-show="false">
            <v-col>
              <div>Volumen Tn</div>
              <v-range-slider
                v-model="rangeVol"
                :max="maxVol"
                :min="minVol"
                dense
                class="align-center"
              >
                <template v-slot:prepend>
                  <v-text-field
                    :value="rangeVol[0]"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                    @change="$set(rangeVol, 0, $event)"
                  ></v-text-field>
                </template>
                <template v-slot:append>
                  <v-text-field
                    :value="rangeVol[1]"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                    @change="$set(rangeVol, 1, $event)"
                  ></v-text-field>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>
          <!-- Filtro de $/TonKm -->
          <v-row no-gutters v-show="false">
            <v-col>
              <div>Costo $MXN/TnKm</div>
              <v-range-slider
                v-model="rangeTonKm"
                :max="maxTonKm"
                :min="minTonKm"
                step="0.1"
                dense
                class="align-center"
              >
                <template v-slot:prepend>
                  <v-text-field
                    :value="rangeTonKm[0]"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    dense
                    type="number"
                    style="width: 60px"
                    @change="$set(rangeTonKm, 0, $event)"
                  ></v-text-field>
                </template>
                <template v-slot:append>
                  <v-text-field
                    :value="rangeTonKm[1]"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    dense
                    type="number"
                    style="width: 60px"
                    @change="$set(rangeTonKm, 1, $event)"
                  ></v-text-field>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>
          
        </v-container>
        </v-card-text>
        <v-card-actions>
          <!-- elementos filtrados -->
          <v-row v-if="getRoutes.length > 0" class="selected">
            <div class="footer-line">
              <div>{{ getSummary.cantidad }} rutas visibles</div> 
              <div>Volumen {{ numberWithCommasND(getSummary.volumen) }} tn. </div>
              <div>$TnS: {{ numberWithCommasND(getSummary.costoTnSeg) }}, $TnE: {{ numberWithCommasND(getSummary.costoTn) }} y $Prod: {{ numberWithCommasND(getSummary.costoTnProd) }}</div>
              </div>
          </v-row>
        </v-card-actions>
        <v-btn color="#1565C0" @click="overlay = false" fab dark small absolute top right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn color="success" title="limpia filtros" @click="clearFilters()" class="mr-12" fab dark small absolute top right>
          <v-icon>mdi-filter-off</v-icon>
        </v-btn>
      </v-card>
    </v-overlay>

    <v-overlay v-model="overlayOptimorum" class="align-center justify-center" contained>
      <v-card light width="360" class="pa-1">
        <h3>Filtros</h3>
        <v-card-text style="max-height:450px;overflow-y:auto;">
        <v-container >
          <!-- filtro de origen-->
          <v-row no-gutters>            
            <v-col>
              <v-combobox multiple v-model="idOrigenOptimorum" :items="itemsListOptimorum" clearable dense label="Origen" class="mt-n4"></v-combobox>
              <!-- filtro de destino-->
              <v-combobox multiple v-model="idDestinoOptimorum" :items="itemsListDestinoOptimorum" clearable dense label="Destino" class="mt-1"></v-combobox>
              <!-- filtro de productos-->
              <v-combobox multiple v-model="productoOptimorum" :items="itemsListProductoOptimorum" clearable dense label="Producto"  class="mt-1"></v-combobox>
              <!-- filtro de saltos-->
              <v-text-field v-model="saltosOptimorum" dense label="Número de saltos" clearable class="mt-0"></v-text-field>
              <!-- filtro de destino-->
              <v-combobox multiple v-model="idPlantaProdOptimorum" :items="itemsListPlantaProdOptimorum" clearable dense label="Planta Productora" class="mt-1"></v-combobox>
              <!-- filtro de destino-->
              <v-combobox multiple v-model="transportesFiltroOptimorum" :items="itemsListTransporteOptimorum" hide-details clearable dense label="Transporte" class="mt-0"></v-combobox>
              <v-row no-gutters justify="space-between" class="mt-1">
                <v-col cols="4">
                  <!-- filtro de costo-->
                  <v-text-field v-model="costoOptimorum" dense label="Costo" clearable class="mt-4"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- filtro de Costo Calculado-->
                  <v-combobox multiple v-model="costoCalculadoOptimorum" :items="itemsCostoCalculadoOptimorum" hide-details clearable label="Costo Calculado" class="mt-0"></v-combobox>
                </v-col>
              </v-row>              
              <v-row no-gutters justify="space-between">
                <v-col cols="4">
                  <!-- filtro de desProd-->
                  <v-text-field v-model="desProdOptimorum" dense label="Llave DP" clearable class="mt-0"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- filtro de ODPT-->
                  <v-text-field v-model="odptOptimorum" dense label="Llave ODPT" clearable class="mt-0"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        </v-card-text>
        <!-- <v-card-actions>
          <v-row v-if="getRoutesOptimorum.length > 0" class="selected">
            <div class="footer-line">
              <div class="titleTablesOp" >PLANEADO</div>
              {{ getSummaryOptimorum.cantidad }} registros y {{ getLlavesUnicas('planeado').length }} rutas visibles con {{ numberWithCommasND(getSummaryOptimorum.volumen) }} tn. $TnSeg: {{ numberWithCommasND(getSummaryOptimorum.costoTnSeg) }}, $Tn: {{ numberWithCommasND(getSummaryOptimorum.costoTn) }} $TnProd: {{ numberWithCommasND(getSummaryOptimorum.costoTnProd) }} e Integral: {{ numberWithCommasND(getSummaryOptimorum.integral) }}
            </div>
            <div class="footer-line">
              <div class="titleTablesOp" >REAL</div>
              {{ getSummaryOptimorumReal.cantidad }} registros y {{ getLlavesUnicas('real').length }} rutas visibles con {{ numberWithCommasND(getSummaryOptimorumReal.volumen) }} tn. $TnSeg: {{ numberWithCommasND(getSummaryOptimorumReal.costoTnSeg) }}, $Tn: {{ numberWithCommasND(getSummaryOptimorumReal.costoTn) }} $TnProd: {{ numberWithCommasND(getSummaryOptimorumReal.costoTnProd) }} e Integral: {{ numberWithCommasND(getSummaryOptimorumReal.integral) }}
            </div>
          </v-row>
        </v-card-actions> -->
        <v-btn color="#1565C0" @click="overlayOptimorum = false" fab dark small absolute top right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn color="success" title="limpia filtros" @click="clearFiltersOptimorum()" class="mr-12" fab dark small absolute top right>
          <v-icon>mdi-filter-off</v-icon>
        </v-btn>
      </v-card>
    </v-overlay>

    <v-overlay v-model="overlayLog" class="align-center justify-center" contained>
      <v-card light width="500" class="pa-3">
        <h3>Detalle Log</h3>
        <v-card-text class="pa-0 ma-0" style="max-height:380px;overflow-y:auto;">
        <v-container >
          <!-- filtro de origen-->
          <v-row no-gutters>            
            <v-col>
              <template v-for="(item,index) in logError">
                <v-row :style="'background-color:#eee;'" no-gutters>
                  <v-col cols="1" class="titleTablesOp">{{ (index+1) }}</v-col>
                  <v-col cols="8" class="titleTablesOp">{{ item.type }}</v-col>
                  <v-col cols="2" class="titleTablesOp">{{ item.scenario }}:{{ item.rowFile }}</v-col>
                </v-row>
                <v-row :style="'background-color:#fff;'" no-gutters>
                  <v-col>{{ item.detail }}</v-col>
                </v-row>
              </template>
              <v-row v-if="logError.length < 1">
                Sin Errores en el procesamiento
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        </v-card-text>
        <v-card-actions>          
        </v-card-actions>
        <v-btn color="#1565C0" @click="overlayLog = false" fab dark small absolute top right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <!-- <v-btn color="success" title="limpia " @click="clearFiltersOptimorum()" class="mr-12" fab dark small absolute top right>
          <v-icon>mdi-filter-off</v-icon>
        </v-btn> -->
      </v-card>
    </v-overlay>

    <v-overlay v-model="overlayNoCostSegments" class="align-center justify-center" contained>
      <v-card light class="pa-2">
        <h3>Detalle Segmentos sin Costo</h3>
        <div>Planeado: {{getNoCostSegments('planeado')}}, Real: {{getNoCostSegments('real')}}</div>
        <v-card-text class="pa-0 ma-0" style="max-height:350px;overflow-y:auto;">
          <table class="mt-5">
            <thead>
              <tr>
                <th>#</th>
                <th>Origen</th>
                <th>Destino</th>
                <th>Producto</th>
                <th>Transporte</th>                    
                <th>Escenario</th>
              </tr>
            </thead>
                <tbody>
                  <tr v-for="(item,index) in noCostSegments">
                    <td>{{ (noCostSegments.length-index) }}</td>
                    <td>{{ item.origen }}</td>
                    <td>{{ item.destino }}</td>
                    <td>{{ item.producto }}</td>
                    <td>{{ item.transporte }}</td>                    
                    <td>{{ item.scenario }}</td>
                  </tr>
                </tbody>
              </table>         
        </v-card-text>
        <v-btn color="#1565C0" @click="overlayNoCostSegments = false" fab dark small absolute top right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn color="#303030" class="mr-12" @click="makeResultNoCostSegment()" fab dark small absolute top right>
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>        
      </v-card>
    </v-overlay>

    <v-overlay v-model="overlayDetalleDP" class="align-center justify-center" contained>
      <v-card light class="pa-2">
        <h3>Volumen por Destino - Producto</h3>        
        <v-card-text class="pa-0 ma-0" style="max-height:350px;overflow-y:auto;">
          <table class="mt-5">
            <thead>
              <tr>
                <th>#</th>
                <th>DesProd</th>
                <th>Destino</th>
                <th>Producto</th>
                <th>TnsP</th>
                <th>TnsR</th>
                <th>Var</th>
                <th>Var%</th>
              </tr>
            </thead>
                <tbody>
                  <tr v-for="(item,index) in desProdDetalle">
                    <td>{{ (desProdDetalle.length-index) }}</td>                    
                    <td>{{ item.desProd }}</td>
                    <td>{{ item.destino }}</td>
                    <td>{{ item.producto }}</td>                    
                    <td>{{ numberWithCommasND(item["planeado"].volumen) }}</td>
                    <td>{{ numberWithCommasND(item["real"].volumen) }}</td>
                    <td>{{ numberWithCommasND(Math.abs(item["planeado"].volumen - item["real"].volumen)) }}</td>
                    <td>{{ numberWithCommasND(item.variacion) }}%</td>
                  </tr>
                </tbody>
              </table>         
        </v-card-text>
        <v-btn color="#1565C0" @click="overlayDetalleDP = false" fab dark small absolute top right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn color="#303030" class="mr-12" @click="makeResultDesProdDetalle()" fab dark small absolute top right>
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>        
      </v-card>
    </v-overlay>

    <div v-show="success" class="fade-in alertBox green" > {{ msgSuccess }} </div>
    <div v-show="error" class="fade-in alertBox red">{{ msgError }}</div>    

    <!-- <v-row>
      <v-snackbar v-model="success" color="success" max-width="200" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
      <v-snackbar v-model="error" color="error" max-width="200" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
    </v-row> -->

  </v-container>
</template>

<script>
import _ from 'lodash'
import * as XLSX from 'xlsx';
import * as Papa from 'papaparse'
import downloadjs from 'downloadjs'
import Mapa from '@/pages/Map.vue'
import Bar from '@/components/Charts/Bar'
import Radar from '@/components/Charts/Radar'
import Pie from '@/components/Charts/Pie'
import PolarArea from '@/components/Charts/PolarArea'
import { EventBus } from "../utils/eventBus.js";


export default {
  name: 'prototype',
  components: { Mapa , Bar, Radar, Pie, PolarArea },
  data: () => ({
    listadoCostoMejor:{},
    listadoCostoMejorPlan:{},
    noCostSegmentsUnicos:{},
    noCostSegments:[],
    costoPromedioKm:[],
    desProd:{},
    desProdDetalle:[],
    odpt:{},
    logError:[],
    listadoUnicos:{}, //unicos de optimorum
    listadoUnicoProductos:{}, //productos unicos de optimorum
    showOptimorumPlaneado: true,
    showOptimorumReal: false,
    encadenadoPlanOficial:{},
    splitMapOptimorum: true,
    currentScenario: 0,
    itemsScenario: [
      { text: 'GES MX', icon: 'mdi-finance', value:'ges' },
      { text: 'OPTIMORUM', icon: 'mdi-bullseye-arrow', value:'optimorum' },
    ],
    sortColumn:'renglon',
    sortDirection: false,
    sortColumnOptimorum:'renglon',
    sortDirectionOptimorum: false,
    sortColumnOptimorumReal:'renglon',
    sortDirectionOptimorumReal: false,
    min: -20000,
    max: 20000,
    range: [-20000, 20000],
    minVol: -1500000,
    maxVol: 1500000,
    rangeVol: [-1500000, 1500000],
    minTonKm: -1000,
    maxTonKm: 1000,
    rangeTonKm: [-1000, 1000],
    limpiaSeleccionMapa: false,
    limpiaSeleccionMapaOptimorum: false,
    selectedKpi: '',
    ajusteVentana: 88,
    loading: false,
    success: false,
    msgSuccess: '',
    error: false,
    msgError: '',    
    mime_types: [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    file: {
      id: [],
      data: null
    },
    plantsOptimorum: {},    // Plant catalog Optimorum
    marcadoresPlantaOptimorum:[], //markers optimorum
    cbOptimorum:{},
    optimorumCemento:[],
    optimorumAbastosPlanOficial:[],
    optimorumAbastosReal:[],
    routesOptimorum:[], // routes optimorum
    routesOptimorumReal:[], // routes optimorumReal
    plants: {},    // Plant catalog
    routes: [],    // Routes
    cb:{},         // Benefit cost id relation
    cost:{},       // Route cost by product
    costSegment:{},// Route cost by product segment
    volume:{},     // Route volume by product
    vehicle:[],    // Vehicle route relation
    vehicleOptimorum:[],    // Vehicle route relation optimorum
    results: [],
    defaultPlant:{},
    sales:[],       // Ventas centro / producto
    materials:{},   // Materiales venta y abasto
    resultsVtas:[], // Costo Logistico y planta
    idOrigen:'',  //origin input filter
    idDestino:'', //destiny input filter
    producto:'',   //product input filter    
    saltos:'',     //jumps in a route
    idPlantaProd:'',
    transportesFiltro:'',
    idOrigenOptimorum:'',  //origin input filter
    idDestinoOptimorum:'', //destiny input filter
    productoOptimorum:'',   //product input filter    
    saltosOptimorum:'',     //jumps in a route    
    idPlantaProdOptimorum:'',
    transportesFiltroOptimorum:'',
    costoCalculadoOptimorum:'',
    costoOptimorum:'', //with segment cost
    desProdOptimorum:'', // key destiny product
    odptOptimorum:'', // key origin destiny product transport
    window: { width: 0, height: 0 },
    showMap: false, //toggle Map show
    fullMap: false, //toggle Map in full mode
    halfMap: false,
    selectedRoute: {}, //No route selected by default
    selectedRouteOptimorum: {}, //No route selected by default
    selectedRouteOptimorumReal: {}, //No route selected by default
    fileUploaded: '',
    fileUploadedOptimorum: '',
    displayFormat:'tabla', //Show either table or summary when shrink
    overlay: false,
    overlayOptimorum: false,
    overlayLog: false,
    overlayNoCostSegments: false,
    overlayDetalleDP: false,
    itemsList:[],    
    itemsListDestino:[],    
    itemsListProducto:[],
    itemsListPlantaProd:[],
    itemsListTransporte:[
      {text:'Auto', value:'Auto'},
      {text:'Barco', value:'Barco'},
      {text:'FFCC', value:'FFCC'},
      {text:'Recogido', value:'Recogido'}
    ],
    itemsListOptimorum:[],    
    itemsListDestinoOptimorum:[],    
    itemsListProductoOptimorum:[],
    itemsListPlantaProdOptimorum:[],
    itemsListTransporteOptimorum:[
      {text:'Auto', value:'Auto'},
      {text:'Barco', value:'Barco'},
      {text:'FFCC', value:'FFCC'},
      {text:'Recogido', value:'Recogido'}
    ],
    itemsCostoCalculadoOptimorum:[
      {text:'Base', value:'0'},
      {text:'Calculado', value:'1'},      
    ],
    marcadoresPlanta:[],
    chartData: {
      labels: [ 
        '00:00', '01:00', '02:00', '03:00', '04:00', '05:00','06:00', '07:00', '08:00', '09:00', '10:00', '11:00',
        '12:00', '13:00', '14:00', '15:00', '16:00', '17:00','18:00', '19:00', '20:00', '21:00', '22:00', '23:00',
      ],
      datasets: 
      [
        {
          data: [7,2,20,10,7],
          borderColor: ['black','black','black','black','black'],
          backgroundColor: ['blue','blue','blue','blue','blue'],
          hoverBackgroundColor: ['green','green','green','green','green'],
          borderWidth: 1,
          order: 2
        },
        {
          type: 'line',
          label: 'Capacidades',
          data: [5,5,5,5,5,5,5,5,5,5,5,5],
          borderColor: 'red',
          pointRadius: 0,
          pointHoverRadius: 0,
          borderWidth: 1,
          backgroundColor: 'rgba(155,205,151, 0)',
          hoverBackgroundColor: 'rgba(155,205,151, 0)',
          order: 1
        }
      ]
    },
    chartDataRadar:{
      labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
      datasets: [
        {
          label: 'My First dataset',
          backgroundColor: 'rgba(179,181,198,0.2)',
          borderColor: 'rgba(179,181,198,1)',
          pointBackgroundColor: 'rgba(179,181,198,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          data: [65, 59, 90, 81, 56, 55, 40]
        },
        {
          label: 'My Second dataset',
          backgroundColor: 'rgba(255,99,132,0.2)',
          borderColor: 'rgba(255,99,132,1)',
          pointBackgroundColor: 'rgba(255,99,132,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(255,99,132,1)',
          data: [28, 48, 40, 19, 96, 27, 100]
        }
      ]
    },
    chartDataPie:{
      labels: ['1 salto', '2 saltos', '3 saltos', '4 saltos','+Mas'],
      datasets: [
        {
          backgroundColor: [
            '#41B883',
            '#E46651',
            '#00D8FF',
            '#DD1B16',
            '#B7A242'
          ],
          data: [40, 20, 80, 10,60]
        }
      ]
    },
    chartDataPolarArea:{
      labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
      datasets: [
        {
          label: 'My First dataset',
          backgroundColor: 'rgba(0,0,180,0.3)',
          pointBackgroundColor: 'rgba(0,0,180,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(0,0,180,1)',
          data: [65, 59, 90, 81, 56, 55, 40]
        },
        {
          label: 'My Second dataset',
          backgroundColor: 'rgba(255,0,0,0.3)',
          pointBackgroundColor: 'rgba(255,0,0,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(255,0,0,1)',
          data: [28, 48, 40, 19, 96, 27, 100]
        }
      ]
    },
    chartOptionsPolarArea:{
      responsive: true,
      animation: { duration: 0 },
      hover: { animationDuration: 0 },
      responsiveAnimationDuration: 0,      
      maintainAspectRatio: false,
    },
    chartOptionsPie:{
      responsive: true,
      animation: { duration: 0 },
      hover: { animationDuration: 0 },
      responsiveAnimationDuration: 0,      
      maintainAspectRatio: false,
    },
    chartOptionsRadar:{
      responsive: true,
      animation: { duration: 0 },
      hover: { animationDuration: 0 },
      responsiveAnimationDuration: 0,      
      maintainAspectRatio: false,
    },
    chartOptions: {
      responsive: true,
      animation: { duration: 0 },
      hover: { animationDuration: 0 },
      responsiveAnimationDuration: 0,
      tooltips: { enabled: false },
      maintainAspectRatio: false,
      legend: { display: false },
      scales: {
        xAxes: [{
          stacked: true,
          barPercentage: 1,
          categoryPercentage: 0.9
        }],
        yAxes: [{
          stacked: true,
          ticks: {
            callback: function(value, index, ticks) {
              return (value / 10)
            }
          }
        }]
      },
      elements: {
        line: {
          tension: 0
        }
      }
    },
    rutasABASTO:[],
    rutasABASTOFiltradasParaMapa:[],
    rutasABASTOOptimorum:[],
    rutasABASTOFiltradasParaMapaOptimorum:[],
    rutasABASTOOptimorumReal:[],
    rutasABASTOFiltradasParaMapaOptimorumReal:[],
    abastoNOM:[],
    entregasNOM:[],
    poligonosNOM:[],
    plantProduct:{},
    chainsBySegment:{}, /*{ 141600_141629_Bco CPC 25k:[[141201,12321],[123432,789543]],...} -> opciones de encadenado por segmento */
    ytdRoutes:[],
    materialesCV:[],
    costoVariable:[],
    abastoMeses:{}, //Objecto con la información de Abasto Meses de Hitos
    abastoMesesAcum:{}, //Objecto con la información de Abasto Meses de Hitos Acumulada al YTD
    months: false,
    itemsListMonths:[],
    mesActual:'',
    meses: {"ENERO":1,"FEBRERO":2,"MARZO":3,"ABRIL":4,"MAYO":5,"JUNIO":6,"JULIO":7,"AGOSTO":8,"SEPTIEMBRE":9,"OCTUBRE":10,"NOVIEMBRE":11,"DICIEMBRE":12},
  }),
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  mounted(){    
    EventBus.$on('sendIndex', coors => {
      console.log(coors)
    });
    EventBus.$on('setOrder', coors => {
      console.log(coors)
    });
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    getCostoMejor(destino,producto){
      return this.listadoCostoMejor[destino+'_'+producto]? this.listadoCostoMejor[destino+'_'+producto] : {costo:0, chain:0}
    },
    getCostoMejorPlan(destino,producto){
      return this.listadoCostoMejorPlan[destino+'_'+producto] ? this.listadoCostoMejorPlan[destino+'_'+producto]: {costo:0, chain:0}
    },
    getNoCostSegments(scenario){
      let count = this.noCostSegments ? this.noCostSegments.filter(function(e) { return e.scenario == scenario }).length:0
      return count
    },
    parseCostoPromedio(items){
      let transporte, presentacion,min,max,costoPromedio
      this.costoPromedioKm = []
      
      for (let i = 1; i < items.length; i++) {
        transporte = items[i][0]
        presentacion = items[i][1]
        min = items[i][2]
        max = items[i][3]
        costoPromedio = items[i][4]
        
        if( !_.isNil(transporte) && !_.isNil(transporte) &&
            !_.isNil(presentacion) && !_.isNil(presentacion) &&            
            !_.isNil(min) && !_.isNil(min) &&
            !_.isNil(max) && !_.isNil(max) &&
            !_.isNil(costoPromedio) && !_.isNil(costoPromedio)
        ){          
          this.costoPromedioKm.push({ transporte, presentacion, min, max, costoPromedio })
        }
      }
    },
    getLlavesUnicas(scenario='planeado'){
      if(scenario == 'planeado'){
        return [...new Set(this.getRoutesOptimorum.map(item => item.keyId))]
      }
      else{
        return [...new Set(this.getRoutesOptimorumReal.map(item => item.keyId))]
      }
    },
    findCBByLocation(location){
      let tempCB = Object.keys(this.cbOptimorum)
      let cb = ''
      for(let x = 0; x < tempCB.length; x++){
        if((this.cbOptimorum[tempCB[x]].descripcion).trim() == (location).trim()){
          cb = this.cbOptimorum[tempCB[x]].id
          break;
        }
      }
      return cb
    },
    parseEncadenado(items, scenario='planeado'){

      let tempAbastos
      if(scenario == 'planeado'){
        tempAbastos = this.optimorumAbastosPlanOficial
        this.listadoUnicos = {}
        this.listadoUnicoProductos ={}
        this.noCostSegments = []
        this.noCostSegmentsUnicos={}
        this.listadoCostoMejor={}
        this.listadoCostoMejorPlan={}
        this.desProd={}
        this.desProdDetalle=[]
      }
      else{
        tempAbastos = this.optimorumAbastosReal
      }
      
      let tempItemsList = []
      let tempItemsListProducto = []
      let origen, destino, keyId, volumen_keyId, rowId, nombre_destino, producto, interfacility_chain, rowId_chain, pct_acum, volumenDesglosado, planta
      let findName, tempNombre, findCosto, costoMejor, costoMejorPlan, costoUltimo, costoProduccion = 0
      let interfacility_chain_mejor, interfacility_chain_mejor_plan= ''
      this.vehicleOptimorum = []
      let distancia = 0
      let origin = {lat:0,lng:0}
      let destiny = {lat:0,lng:0}
      let fleteCalc = 0
      let rangeIndex = 0
      let costoPromedioKmAuto= []
      let costoPromedioKmFFCC= []
      let last = ''
      let segmentPpt = ''
      let origenSegmento=''
      let destinoSegmento=''
      let bCostoCalculado = false

      for (let i = 1; i < items.length; i++) {
        
        bCostoCalculado = false

        keyId = items[i][2]*1
        volumen_keyId = items[i][3]*1
        rowId = items[i][4]*1
        nombre_destino = items[i][6]
        producto = items[i][7]
        interfacility_chain = items[i][9]
        rowId_chain = items[i][10].split('|').slice(2).slice(0, -1)
        pct_acum = items[i][22]*1
        volumenDesglosado = Math.round(items[i][23] * 100) / 100

        if(items[i][11]*1 < 2){// No busca encadenado solo actualiza costo producto

          let findName = this.findByMatchingProperties(tempAbastos, {
            rowId: rowId_chain[0]*1
          })

          if(findName.length > 0){
            let findCosto = this.findByMatchingProperties(this.optimorumCemento, {
              nombre_origen: findName[0].nombre_origen,
              nombre_destino: findName[0].nombre_destino,
              descr_producto: findName[0].descr_producto,
              transporte: findName[0].transporte
            })
            costoProduccion = findCosto[0].costo_producto
          }
          continue;          
        }
        
        planta = this.findCBByLocation(items[i][24])
        destino = this.findCBByLocation(nombre_destino)

        //Llave destino-producto para filtro
        if(!this.desProd[nombre_destino + "_" + producto]){
          this.desProd[nombre_destino + "_" + producto] = Object.keys(this.desProd).length
          this.desProdDetalle.push({ id: nombre_destino + "_" + producto, desProd: this.desProd[nombre_destino + "_" + producto], destino:nombre_destino, producto, volumen: 0, variacion:100, planeado: { volumen:0 }, real: { volumen:0 } })
        }
        let objIndex = this.desProdDetalle.findIndex(obj => obj.id == nombre_destino + "_" + producto);
        this.desProdDetalle[objIndex]["volumen"] +=  ( items[i][23] * 1 )        
        this.desProdDetalle[objIndex][scenario]["volumen"] +=  ( items[i][23] * 1 )
        this.desProdDetalle[objIndex]["variacion"] = this.desProdDetalle[objIndex]["planeado"].volumen == 0 ? 100: Math.abs((this.desProdDetalle[objIndex]["real"].volumen / this.desProdDetalle[objIndex]["planeado"].volumen)-1)*100

        // Llena rellena encadenados 
        let cadena = []
        let puntos =[]
        let cadenaNombres = []
        let cadenaTipoRegistro = []        
        let cadenaCostoTramo = []
        let cadenaAcumCosto = []
        let cadenaProducto = []
        let cadenaTransporte = []
        let cadenaVolumen = []
        let cadenaVolumenTramo = []
        let cadenaCostoCalculado = []
        let saltos = 0
        origen=''

        for(let w= 0; w < rowId_chain.length; w++){          
          
          findName = this.findByMatchingProperties(tempAbastos, {
            rowId: rowId_chain[w]*1
          })
          tempNombre = findName.length > 0 ?findName[0].tipo_registro == 'Produccion'? findName[0].nombre_destino : findName[0].nombre_origen:''
          if(findName.length > 0){
            origenSegmento = this.findCBByLocation(tempNombre)
            destinoSegmento = this.findCBByLocation(findName[0].nombre_destino)
            
            if(findName[0].tipo_registro != 'Produccion'){
              cadena.push(origenSegmento)
              cadenaNombres.push(tempNombre)
              cadenaTipoRegistro.push(findName[0].tipo_registro)
              cadenaProducto.push(findName[0].descr_producto)
              cadenaTransporte.push(findName[0].transporte)
              cadenaVolumen.push(volumenDesglosado)
              cadenaVolumenTramo.push(findName[0].volumen_red)

              if(this.cbOptimorum[origenSegmento] !== undefined){          
                puntos.push({
                  id: origenSegmento,
                    extra:{
                      idsap: this.cbOptimorum[origenSegmento].idsap                
                    },
                    nombre: this.cbOptimorum[origenSegmento].descripcion,
                    ubicacion:{
                      lat: this.cbOptimorum[origenSegmento].lat*1,
                      lng: this.cbOptimorum[origenSegmento].lng*1
                    }
                })
              }

            }

            findCosto = this.findByMatchingProperties(this.optimorumCemento, {
              nombre_origen: findName[0].nombre_origen,
              nombre_destino: findName[0].nombre_destino,
              descr_producto: findName[0].descr_producto,
              transporte: findName[0].transporte
            })            

            if(findCosto.length > 0 && findCosto[0].costo_flete !== 4000){
              if(findName[0].tipo_registro == 'Produccion'){
                costoProduccion = findCosto[0].costo_producto
              }
              else{
                  costoUltimo = cadenaAcumCosto.length > 0 ? cadenaAcumCosto[cadenaAcumCosto.length-1] : 0
                  cadenaCostoTramo.push(findCosto[0].costo_flete)
                  cadenaAcumCosto.push(costoUltimo + findCosto[0].costo_flete)
                  saltos+=1
                  cadenaCostoCalculado.push({value: 0, detail: ''})
              }
            }
            else{
              
              if(findName[0].tipo_registro != 'Produccion'){
                bCostoCalculado = true
                saltos+=1
                
                if(findName[0].transporte != 'Recogido' && !this.noCostSegmentsUnicos[tempNombre+'_'+findName[0].nombre_destino+'_'+findName[0].descr_producto+'_'+findName[0].transporte+'_'+scenario]){
                  this.noCostSegments.push({ origen: tempNombre, destino: findName[0].nombre_destino, producto: findName[0].descr_producto, transporte: findName[0].transporte, scenario})
                  this.noCostSegmentsUnicos[tempNombre+'_'+findName[0].nombre_destino+'_'+findName[0].descr_producto+'_'+findName[0].transporte+'_'+scenario]=1
                }

                distancia = 0
                origin = this.cbOptimorum[origenSegmento]? {lat: this.cbOptimorum[origenSegmento].lat*1, lng:this.cbOptimorum[origenSegmento].lng*1} : {lat:0,lng:0}
                destiny = this.cbOptimorum[destinoSegmento]? {lat: this.cbOptimorum[destinoSegmento].lat*1, lng:this.cbOptimorum[destinoSegmento].lng*1} : {lat:0,lng:0}

                if(!(origin.lat==0 || origin.lng==0 || destiny.lat==0 || destiny.lng==0)){
                  distancia = this.haversine_distance(origin,destiny)*1
                }

                costoUltimo = cadenaAcumCosto.length > 0 ? cadenaAcumCosto[cadenaAcumCosto.length-1] : 0
                // como hay 20 segmentos de 50km en costoPromKm por transporte
                rangeIndex = Math.floor(distancia/50) > 19 ? 19 : Math.floor(distancia/50)
                
                if(findName[0].transporte == 'Auto'){
                  last = findName[0].descr_producto.split(' ').slice(-1)[0]
                  segmentPpt = last.indexOf('k')> -1 || last.indexOf('BB') > -1 ? 'Sacos':'Granel'
                  costoPromedioKmAuto = this.costoPromedioKm.length > 0 ? this.costoPromedioKm.filter(function(e) { return e.transporte == findName[0].transporte && e.presentacion == segmentPpt }) : []
                  fleteCalc = costoPromedioKmAuto[rangeIndex] ? (costoPromedioKmAuto[rangeIndex].costoPromedio * distancia) : 0
                  cadenaCostoTramo.push(fleteCalc)
                  cadenaAcumCosto.push(costoUltimo + fleteCalc)
                  cadenaCostoCalculado.push({value: 1, detail: (fleteCalc/distancia) +' * '+ (Math.round(distancia*100)/100) + ' km'})
                }
                else if(findName[0].transporte=='FFCC'){
                  costoPromedioKmFFCC = this.costoPromedioKm.length > 0 ? this.costoPromedioKm.filter(function(e) { return e.transporte == findName[0].transporte && e.presentacion == 'FFCC' }) : []                  
                  fleteCalc = costoPromedioKmFFCC[rangeIndex] ? (costoPromedioKmFFCC[rangeIndex].costoPromedio * distancia) : 0
                  cadenaCostoTramo.push(fleteCalc)
                  cadenaAcumCosto.push(costoUltimo + fleteCalc)
                  cadenaCostoCalculado.push({value: 1, detail: (fleteCalc/distancia) +' * '+ (Math.round(distancia*100)/100) + ' km'})
                }
                else{                  
                  cadenaCostoTramo.push(0)
                  cadenaAcumCosto.push(costoUltimo)
                  cadenaCostoCalculado.push({value: 0, detail: ''})
                }
              }
              else{
                costoProduccion = 0
                if(findName[0].descr_producto == 'Antihumedad 25k'){
                  findCosto = this.findByMatchingProperties(this.optimorumCemento, {
                    nombre_origen: findName[0].nombre_origen,
                    nombre_destino: findName[0].nombre_destino,
                    descr_producto: 'CPC30R',
                    transporte: findName[0].transporte
                  })
                  if(findCosto.length > 0){
                    costoProduccion = (findCosto[0].costo_producto*1)+200
                  }
                }
                if(findName[0].descr_producto == 'Mortero 25k'){
                  findCosto = this.findByMatchingProperties(this.optimorumCemento, {
                    nombre_origen: findName[0].nombre_origen,
                    nombre_destino: findName[0].nombre_destino,
                    descr_producto: 'Mortero',
                    transporte: findName[0].transporte
                  })
                  if(findCosto.length > 0){
                    costoProduccion = (findCosto[0].costo_producto*1)
                  }
                }
                if(findName[0].descr_producto == 'CPC30R 25k'){
                  findCosto = this.findByMatchingProperties(this.optimorumCemento, {
                    nombre_origen: findName[0].nombre_origen,
                    nombre_destino: findName[0].nombre_destino,
                    descr_producto: 'CPC30R 50k',
                    transporte: findName[0].transporte
                  })
                  if(findCosto.length > 0){
                    costoProduccion = (findCosto[0].costo_producto*1)
                  }
                }
                
              }
            }
          }
        }

        //Se mete el origen y destino de abastos del rowId para completar cadena
        findName = this.findByMatchingProperties(tempAbastos, {
          rowId: items[i][4]*1
        })

        tempNombre = findName.length > 0 ?findName[0].tipo_registro == 'Produccion'? findName[0].nombre_destino : findName[0].nombre_origen:''
        if(findName.length > 0){
          origenSegmento = this.findCBByLocation(tempNombre)
          destinoSegmento = this.findCBByLocation(findName[0].nombre_destino)
          origen = this.findCBByLocation(tempNombre)
          
          if(findName[0].tipo_registro != 'Produccion'){            
            cadena.push(origenSegmento);
            cadena.push(destinoSegmento);
            cadenaNombres.push(findName[0].nombre_origen);
            cadenaNombres.push(findName[0].nombre_destino);
            cadenaTipoRegistro.push(findName[0].tipo_registro);
            cadenaProducto.push(findName[0].descr_producto);
            cadenaTransporte.push(findName[0].transporte);
            cadenaVolumen.push(findName[0].volumen_red);
            cadenaVolumenTramo.push(volumenDesglosado);

            [origenSegmento,destinoSegmento].forEach(location =>{
              if(this.cbOptimorum[location] !== undefined){
                puntos.push({
                  id: location,
                    extra:{
                      idsap: this.cbOptimorum[location].idsap                
                    },
                    nombre: this.cbOptimorum[location].descripcion,
                    ubicacion:{
                      lat: this.cbOptimorum[location].lat*1,
                      lng: this.cbOptimorum[location].lng*1
                    }
                })
              }
            })
          }
                    
          findCosto = this.findByMatchingProperties(this.optimorumCemento, {
            nombre_origen: findName[0].nombre_origen,
            nombre_destino: findName[0].nombre_destino,
            descr_producto: findName[0].descr_producto,
            transporte: findName[0].transporte
          })

          //Llave origen-destino-producto-transporte para filtro
          if(!this.odpt[findName[0].nombre_origen + "_" + nombre_destino + "_" + findName[0].descr_producto + "_" + findName[0].transporte]){
            this.odpt[findName[0].nombre_origen + "_" + nombre_destino + "_" + findName[0].descr_producto + "_" + findName[0].transporte] = Object.keys(this.odpt).length
          }

          if(findCosto.length > 0 && findCosto[0].costo_flete !== 4000){
            if(findName[0].tipo_registro == 'Produccion'){
              costoProduccion = findCosto[0].costo_producto
            }
            else{
                costoUltimo = cadenaAcumCosto.length > 0 ? cadenaAcumCosto[cadenaAcumCosto.length-1] : 0
                cadenaCostoTramo.push(findCosto[0].costo_flete)
                cadenaAcumCosto.push(costoUltimo + findCosto[0].costo_flete)
                saltos+=1
                cadenaCostoCalculado.push({value: 0, detail: ''})
            }
          }
          else{
            
            if(findName[0].tipo_registro != 'Produccion'){
              bCostoCalculado = true;
              saltos+=1

              if(findName[0].transporte != 'Recogido' && !this.noCostSegmentsUnicos[tempNombre+'_'+findName[0].nombre_destino+'_'+findName[0].descr_producto+'_'+findName[0].transporte+'_'+scenario]){
                this.noCostSegments.push({ origen: tempNombre, destino: findName[0].nombre_destino, producto: findName[0].descr_producto, transporte: findName[0].transporte, scenario})
                this.noCostSegmentsUnicos[tempNombre+'_'+findName[0].nombre_destino+'_'+findName[0].descr_producto+'_'+findName[0].transporte+'_'+scenario]=1
              }

              distancia = 0
              origin = this.cbOptimorum[origenSegmento]? {lat: this.cbOptimorum[origenSegmento].lat*1, lng:this.cbOptimorum[origenSegmento].lng*1} : {lat:0,lng:0}
              destiny = this.cbOptimorum[destinoSegmento]? {lat: this.cbOptimorum[destinoSegmento].lat*1, lng:this.cbOptimorum[destinoSegmento].lng*1} : {lat:0,lng:0}

              if(!(origin.lat==0 || origin.lng==0 || destiny.lat==0 || destiny.lng==0)){
                distancia = this.haversine_distance(origin,destiny)*1
              }

              costoUltimo = cadenaAcumCosto.length > 0 ? cadenaAcumCosto[cadenaAcumCosto.length-1] : 0
              // como hay 20 segmentos de 50km en costoPromKm por transporte
              rangeIndex = Math.floor(distancia/50) > 19 ? 19 : Math.floor(distancia/50)
              
              if(findName[0].transporte == 'Auto'){
                last = findName[0].descr_producto.split(' ').slice(-1)[0]
                segmentPpt = last.indexOf('k')> -1 || last.indexOf('BB') > -1 ? 'Sacos':'Granel'
                costoPromedioKmAuto = this.costoPromedioKm.length > 0 ? this.costoPromedioKm.filter(function(e) { return e.transporte == findName[0].transporte && e.presentacion == segmentPpt }) : []
                fleteCalc = costoPromedioKmAuto[rangeIndex] ? (costoPromedioKmAuto[rangeIndex].costoPromedio * distancia) : 0
                cadenaCostoTramo.push(fleteCalc)
                cadenaAcumCosto.push(costoUltimo + fleteCalc)
                cadenaCostoCalculado.push({value: 1, detail: (fleteCalc/distancia) +' * '+ (Math.round(distancia*100)/100) + ' km'})
              }
              else if(findName[0].transporte=='FFCC'){
                costoPromedioKmFFCC = this.costoPromedioKm.length > 0 ? this.costoPromedioKm.filter(function(e) { return e.transporte == findName[0].transporte && e.presentacion == 'FFCC' }) : []
                fleteCalc = costoPromedioKmFFCC[rangeIndex] ? (costoPromedioKmFFCC[rangeIndex].costoPromedio * distancia) : 0
                cadenaCostoTramo.push(fleteCalc)
                cadenaAcumCosto.push(costoUltimo + fleteCalc)
                cadenaCostoCalculado.push({value: 1, detail: (fleteCalc/distancia) +' * '+ (Math.round(distancia*100)/100) + ' km'})
              }
              else{
                cadenaCostoTramo.push(0)
                cadenaAcumCosto.push(costoUltimo)
                cadenaCostoCalculado.push({value: 0, detail: ''})
              }
            }
            else{
              costoProduccion = 0
              if(findName[0].descr_producto == 'Antihumedad 25k'){
                findCosto = this.findByMatchingProperties(this.optimorumCemento, {
                  nombre_origen: findName[0].nombre_origen,
                  nombre_destino: findName[0].nombre_destino,
                  descr_producto: 'CPC30R',
                  transporte: findName[0].transporte
                })
                if(findCosto.length > 0){
                  costoProduccion = (findCosto[0].costo_producto*1)+200
                }
              }
              if(findName[0].descr_producto == 'Mortero 25k'){
                findCosto = this.findByMatchingProperties(this.optimorumCemento, {
                  nombre_origen: findName[0].nombre_origen,
                  nombre_destino: findName[0].nombre_destino,
                  descr_producto: 'Mortero',
                  transporte: findName[0].transporte
                })
                if(findCosto.length > 0){
                  costoProduccion = (findCosto[0].costo_producto*1)
                }
              }
              if(findName[0].descr_producto == 'CPC30R 25k'){
                findCosto = this.findByMatchingProperties(this.optimorumCemento, {
                  nombre_origen: findName[0].nombre_origen,
                  nombre_destino: findName[0].nombre_destino,
                  descr_producto: 'CPC30R 50k',
                  transporte: findName[0].transporte
                })
                if(findCosto.length > 0){
                  costoProduccion = (findCosto[0].costo_producto*1)
                }
              }
            }
          }
        }

        let distancia = 0
        let origin = this.cbOptimorum[origen]? {lat: this.cbOptimorum[origen].lat*1, lng:this.cbOptimorum[origen].lng*1} : {lat:0,lng:0}
        let destiny = this.cbOptimorum[destino]? {lat: this.cbOptimorum[destino].lat*1, lng:this.cbOptimorum[destino].lng*1} : {lat:0,lng:0}

        if(!(origin.lat==0 || origin.lng==0 || destiny.lat==0 || destiny.lng==0)){
          distancia = this.haversine_distance(origin,destiny)*1
        }
        
        let costoRuta = cadenaAcumCosto.length>0 ? cadenaAcumCosto[cadenaAcumCosto.length-1] : 0
        let costoTramo = cadenaCostoTramo.length>0 ? cadenaCostoTramo[cadenaCostoTramo.length-1] : 0

        /* const findVehicle = this.findByMatchingProperties(this.vehicle, {
          idOrigen:  origen,
          idDestino: destino,
          producto: producto
        }) */
                  
        let vehiculos = [...cadenaTransporte].join('|').trim()
        let transportes = [...cadenaTransporte].join('|').trim()

        if(cadenaTransporte.length<1){
          cadenaTransporte.push('SinDefinir')
        }
        transportes = transportes =='' ? 'SinDefinir' : transportes
        
        let costoTramoKm = distancia < 1 ? -1 : this.numberWithCommas(costoTramo / distancia)

        let origenNombre = tempNombre
        let destinoNombre = nombre_destino


        if(puntos.length < 1){
          //No encontró cadena, se va a mandar al origen
          let registro = {idsap:'',descripcion: origen,lat:0,long:0}
          if(this.cbOptimorum[origen]){
            registro =  { idsap: this.cbOptimorum[origen].idsap,
                          descripcion: this.cbOptimorum[origen].descripcion,
                          lat: this.cbOptimorum[origen].lat,
                          long: this.cbOptimorum[origen].lng
                        }
          }
          puntos.push({
            id: origen,
              extra:{
                idsap: registro.idsap
              },
              nombre: registro.descripcion,
              ubicacion:{
                lat: registro.lat*1,
                lng: registro.lng*1
              }
          })
        }

        //Busca costo mejor y lo deja en listadoCostoMejor
        costoMejor = (costoProduccion*1+costoRuta*1)
        interfacility_chain_mejor = interfacility_chain

        costoMejorPlan = (costoProduccion*1+costoRuta*1)
        interfacility_chain_mejor_plan = interfacility_chain
        
        if(interfacility_chain.slice(-11) != '[Recogido]|' && !(puntos.some(e => (e.ubicacion.lat === 0 || e.ubicacion.lng === 0 )))){

          if(!this.listadoCostoMejor[destinoNombre+"_"+producto]){
            this.listadoCostoMejor[destinoNombre+"_"+producto] = {costo: costoMejor, chain: interfacility_chain_mejor}
          }
          else{
            if(this.listadoCostoMejor[destinoNombre+"_"+producto].costo > costoMejor){
              this.listadoCostoMejor[destinoNombre+"_"+producto].costo = costoMejor*1
              this.listadoCostoMejor[destinoNombre+"_"+producto].chain = interfacility_chain_mejor
            }
            else{
              costoMejor = this.listadoCostoMejor[destinoNombre+"_"+producto].costo
              interfacility_chain_mejor = this.listadoCostoMejor[destinoNombre+"_"+producto].chain
            }
          }

          if(scenario=='planeado'){

            if(!this.listadoCostoMejorPlan[destinoNombre+"_"+producto]){
              this.listadoCostoMejorPlan[destinoNombre+"_"+producto] = {costo: costoMejorPlan, chain: interfacility_chain_mejor}
            }
            else{
              if(this.listadoCostoMejorPlan[destinoNombre+"_"+producto].costo > costoMejorPlan){
                this.listadoCostoMejorPlan[destinoNombre+"_"+producto].costo = costoMejorPlan*1
                this.listadoCostoMejorPlan[destinoNombre+"_"+producto].chain = interfacility_chain_mejor_plan
              }
              else{
                costoMejorPlan = this.listadoCostoMejorPlan[destinoNombre+"_"+producto].costo
                interfacility_chain_mejor_plan = this.listadoCostoMejorPlan[destinoNombre+"_"+producto].chain
              }
            }
          }
          else{
            costoMejorPlan = this.listadoCostoMejorPlan[destinoNombre+"_"+producto] ? this.listadoCostoMejorPlan[destinoNombre+"_"+producto].costo : 0
            interfacility_chain_mejor_plan = this.listadoCostoMejorPlan[destinoNombre+"_"+producto] ? this.listadoCostoMejorPlan[destinoNombre+"_"+producto].chain :''
          }
        }
        // End costo mejor


        if (!_.isNil(origen) && origen.trim() !== '' && !_.isNil(destino) && destino.trim() !== '' && !_.isNil(producto) && producto.trim() !== '') {
          if(scenario=='planeado'){
            
            this.routesOptimorum.push({renglon:(i+1),idOrigen: origen, idDestino: destino, producto, cadena, puntos, cadenaNombres, cadenaCosto:cadenaAcumCosto, cadenaCostoTramo, cadenaAcumCosto, planta, costoProduccion, cadenaProducto, prodDif:0, saltos, cadenaVehiculo:[], volumen:volumenDesglosado, volumenTramo:volumenDesglosado, cadenaVolumenTramo,cadenaVolumen, cadenaTransporte, cadenaDistancias:[], distancia, costoTramo, costoRuta, costoTotal:(costoProduccion*1+costoRuta*1),costoMejor,ahorroPot:0, interfacility_chain_mejor, costoMejorPlan,ahorroPotPlan:0, interfacility_chain_mejor_plan, transporteTramo: transportes, vehiculoTramo: vehiculos, costoTramoKm, origenNombre, destinoNombre, cadenaTipoRegistro,keyId,volumen_keyId,rowId,interfacility_chain,rowId_chain,pct_acum, desProd:this.desProd[destinoNombre+"_"+producto], odpt:this.odpt[origenNombre+"_"+destinoNombre+"_"+producto+"_"+cadenaTransporte[cadenaTransporte.length-1]], bCostoCalculado, cadenaCostoCalculado})
          }
          else{
            this.routesOptimorumReal.push({renglon:(i+1),idOrigen: origen, idDestino: destino, producto, cadena, puntos, cadenaNombres, cadenaCosto:cadenaAcumCosto, cadenaCostoTramo, cadenaAcumCosto, planta, costoProduccion, cadenaProducto, prodDif:0, saltos, cadenaVehiculo:[], volumen:volumenDesglosado, volumenTramo:volumenDesglosado, cadenaVolumenTramo,cadenaVolumen, cadenaTransporte, cadenaDistancias:[], distancia, costoTramo, costoRuta, costoTotal:(costoProduccion*1+costoRuta*1),costoMejor,ahorroPot:0, interfacility_chain_mejor,costoMejorPlan,ahorroPotPlan:0, interfacility_chain_mejor_plan,transporteTramo: transportes, vehiculoTramo: vehiculos, costoTramoKm, origenNombre, destinoNombre, cadenaTipoRegistro,keyId,volumen_keyId,rowId,interfacility_chain,rowId_chain,pct_acum, desProd:this.desProd[destinoNombre+"_"+producto], odpt:this.odpt[origenNombre+"_"+destinoNombre+"_"+producto+"_"+cadenaTransporte[cadenaTransporte.length-1]], bCostoCalculado, cadenaCostoCalculado})
          }
        }
        else{
          let detailError=''
          detailError = detailError + (!_.isNil(origen) && origen.trim() !== ''? '' : 'Origen ')
          detailError = detailError + (!_.isNil(destino) && destino.trim() !== ''? '' : 'Destino ')
          detailError = detailError + (!_.isNil(producto) && producto.trim() !== ''? '' : 'Producto')
          this.logError.push({type:'ERROR! -> '+detailError, scenario, rowFile:(i+1), detail:JSON.stringify(rowId_chain)+', '+producto+', O:'+origen+'['+tempNombre+'], D:'+destino+'['+nombre_destino+'], P:'+producto})
        }
        this.listadoUnicos[origen]=1
        this.listadoUnicos[destino]=1
        this.listadoUnicoProductos[producto]=1
      }
      
      //Actualiza costoMejor en Rutas
      let tempMejor =[]
      let tempMejorPlan =[]
      
        this.routesOptimorum.forEach( ruta =>{
          tempMejor = this.getCostoMejor(ruta.destinoNombre, ruta.producto)
          ruta.costoMejor = tempMejor.costo
          ruta.interfacility_chain_mejor = tempMejor.chain
          ruta.ahorroPot = ruta.costoMejor > 0 ?(ruta.costoTotal - ruta.costoMejor) * ruta.volumenTramo : 0

          tempMejorPlan = this.getCostoMejorPlan(ruta.destinoNombre, ruta.producto)
          ruta.costoMejorPlan = tempMejorPlan.costo
          ruta.interfacility_chain_mejor_plan = tempMejorPlan.chain
          ruta.ahorroPotPlan = ruta.costoMejorPlan > 0 ?(ruta.costoTotal - ruta.costoMejorPlan) * ruta.volumenTramo : 0
        })
      
        this.routesOptimorumReal.forEach( ruta =>{
          tempMejor = this.getCostoMejor(ruta.destinoNombre, ruta.producto)
          ruta.costoMejor = tempMejor.costo
          ruta.interfacility_chain_mejor = tempMejor.chain
          ruta.ahorroPot = ruta.costoMejor > 0 ?(ruta.costoTotal - ruta.costoMejor) * ruta.volumenTramo : 0

          tempMejorPlan = this.getCostoMejorPlan(ruta.destinoNombre, ruta.producto)
          ruta.costoMejorPlan = tempMejorPlan.costo
          ruta.interfacility_chain_mejor_plan = tempMejorPlan.chain
          ruta.ahorroPotPlan = ruta.costoMejorPlan > 0 ?(ruta.costoTotal - ruta.costoMejorPlan) * ruta.volumenTramo : 0
        })
      


      //console.log(this.routesOptimorum)
      //console.log(this.optimorumCemento)

      let tempListKeys = Object.keys(this.listadoUnicos)
      tempListKeys.forEach(entry =>{
        if(this.cbOptimorum[entry]){          
          tempItemsList.push({ text:entry+' '+this.cbOptimorum[entry].idsap+' '+this.cbOptimorum[entry].descripcion, value: entry, descripcion: this.cbOptimorum[entry].descripcion})
        }
      })
      tempItemsList.sort(function(a,b){
        if (!isNaN(parseFloat(a.descripcion)) && !isNaN(parseFloat(b.descripcion))){
          return b.descripcion - a.descripcion;
        }
        else{
          if ( a.descripcion < b.descripcion ) return -1;
          if ( a.descripcion > b.descripcion ) return 1;
          return 0;
        }
      });
      this.itemsListOptimorum = [...tempItemsList]
      this.itemsListDestinoOptimorum = [...tempItemsList]
      this.itemsListPlantaProdOptimorum = tempItemsList.filter( elem => elem.descripcion.toUpperCase().indexOf("PLANTA")> -1 || elem.descripcion.toUpperCase().indexOf("PTA.")> -1)
      this.itemsListPlantaProdOptimorum.unshift({ text:'SIN PLANTA', value: '', descripcion: ''})

      let tempListKeysProductos = Object.keys(this.listadoUnicoProductos)
      tempListKeysProductos.forEach(entry =>{
        tempItemsListProducto.push({ text:entry, value: entry, descripcion: entry })
      })
      tempItemsListProducto.sort(function(a,b){
        if (!isNaN(parseFloat(a.descripcion)) && !isNaN(parseFloat(b.descripcion))){
          return b.descripcion - a.descripcion;
        }
        else{
          if ( a.descripcion < b.descripcion ) return -1;
          if ( a.descripcion > b.descripcion ) return 1;
          return 0;
        }
      });      
      this.itemsListProductoOptimorum = [...tempItemsListProducto]

      //Ordena el detalle de destino-producto
      this.desProdDetalle.sort(function(a,b){
        if (!isNaN(parseFloat(a.volumen)) && !isNaN(parseFloat(b.volumen))){
          return b.volumen - a.volumen || b.variacion - a.variacion;
        }
        else{
          if ( a.volumen < b.volumen ) return -1;
          if ( a.volumen > b.volumen ) return 1;
          return 0;
        }
      });      

    },
    parseAbastos(items, scenario='planeado'){
      let nombre_origen, nombre_destino, descr_producto, descr_producto_inp, transporte, volumen_red, tipo_registro, rowId
      
      for (let i = 1; i < items.length; i++) {
        nombre_origen = items[i][2]
        nombre_destino = items[i][3]
        descr_producto = items[i][4]
        descr_producto_inp = items[i][5]
        transporte = items[i][6]
        volumen_red = items[i][7]
        tipo_registro = items[i][10]
        rowId = items[i][11]*1
        if( !_.isNil(nombre_origen) && !_.isNil(nombre_origen) &&
            !_.isNil(nombre_destino) && !_.isNil(nombre_destino) &&            
            !_.isNil(descr_producto) && !_.isNil(descr_producto) &&
            !_.isNil(descr_producto_inp) && !_.isNil(descr_producto_inp) &&
            !_.isNil(transporte) && !_.isNil(transporte) &&
            !_.isNil(volumen_red) && !_.isNil(volumen_red) &&
            !_.isNil(tipo_registro) && !_.isNil(tipo_registro) &&
            !_.isNil(rowId) && !_.isNil(rowId)
        ){
          if(scenario == 'planeado'){
            this.optimorumAbastosPlanOficial.push({ nombre_origen, nombre_destino, descr_producto, descr_producto_inp, transporte, volumen_red, tipo_registro, rowId })
          }
          else{
            this.optimorumAbastosReal.push({ nombre_origen, nombre_destino, descr_producto, descr_producto_inp, transporte, volumen_red, tipo_registro, rowId })
          }
        }
      }
    },
    parseOptimorumCemento(items){
      let origen, nombre_origen, destino, nombre_destino, estructura, agrup_producto, presentacion, descr_producto, transporte, costo_producto, costo_flete
      for (let i = 1; i < items.length; i++) {
        origen = items[i][0]
        nombre_origen = items[i][1]
        destino = items[i][2]
        nombre_destino = items[i][3]
        estructura = items[i][4]
        agrup_producto = items[i][5]
        presentacion = items[i][6]
        descr_producto = items[i][7]
        transporte = items[i][8]
        costo_producto = items[i][23]*1
        costo_flete = items[i][24]*1
        if( !_.isNil(origen) && !_.isNil(origen) !== '' && 
            !_.isNil(nombre_origen) && !_.isNil(nombre_origen) &&
            !_.isNil(destino) && !_.isNil(destino) &&
            !_.isNil(nombre_destino) && !_.isNil(nombre_destino) &&
            !_.isNil(estructura) && !_.isNil(estructura) &&
            !_.isNil(agrup_producto) && !_.isNil(agrup_producto) &&
            !_.isNil(presentacion) && !_.isNil(presentacion) &&
            !_.isNil(descr_producto) && !_.isNil(descr_producto) &&
            !_.isNil(transporte) && !_.isNil(transporte) &&
            !_.isNil(costo_producto) && !_.isNil(costo_producto) &&
            !_.isNil(costo_flete) && !_.isNil(costo_flete)
        ){
          this.optimorumCemento.push({ origen, nombre_origen, destino, nombre_destino, estructura, agrup_producto, presentacion, descr_producto, transporte, costo_producto, costo_flete })
        }
      }
    },
    setColumnSort(column){
      if(this.sortColumn == column){
        this.sortDirection = !this.sortDirection
      }
      else{
        this.sortDirection = true
      }
      this.sortColumn = column
    },
    setColumnSortOptimorum(column){
      if(this.sortColumnOptimorum == column){
        this.sortDirectionOptimorum = !this.sortDirectionOptimorum
      }
      else{
        this.sortDirectionOptimorum = true
      }
      this.sortColumnOptimorum = column
    },
    setColumnSortOptimorumReal(column){
      if(this.sortColumnOptimorumReal == column){
        this.sortDirectionOptimorumReal = !this.sortDirectionOptimorumReal
      }
      else{
        this.sortDirectionOptimorumReal = true
      }
      this.sortColumnOptimorumReal = column
    },
    getVariableCost(plant, product){
      //console.log("mat y costovar",this.materialesCV,this.costoVariable)
      let result = 0
      let findKey = this.findByMatchingProperties(this.materialesCV, { matAbasto: product })
      if(findKey.length > 0){
        let findCost = this.findByMatchingProperties(this.costoVariable, {
          keyAbasto: findKey[0].gpo+""+plant
        })
        if(findCost.length > 0){
          result = findCost[0].costo
        }
      }      
      return result
    },
    clearFilters(limpia='todos'){
      this.idOrigen= []
      this.idDestino= []
      this.producto= []
      this.saltos= ""
      this.idPlantaProd=[]
      this.transportesFiltro=[]
    },
    clearFiltersOptimorum(limpia='todos'){
      this.idOrigenOptimorum= []
      this.idDestinoOptimorum= []
      this.productoOptimorum= []
      this.saltosOptimorum= ""
      this.idPlantaProdOptimorum=[]
      this.transportesFiltroOptimorum=[]
      this.costoOptimorum=""
      this.desProdOptimorum=""
      this.odptOptimorum=""
      this.costoCalculadoOptimorum=[]
    },
    haversine_distance(mk1={lat:0,lng:0}, mk2={lat:0,lng:0}) {
      
      var R = 6371.0710 // 3958.8 Radius of the Earth in miles
      var rlat1 = mk1.lat * (Math.PI/180); // Convert degrees to radians
      var rlat2 = mk2.lat * (Math.PI/180); // Convert degrees to radians
      
      var difflat = rlat2-rlat1; // Radian difference (latitudes)
      var difflon = (mk2.lng-mk1.lng) * (Math.PI/180); // Radian difference (longitudes)

      var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
      return d*1.25;
    },
    sendFilteredRoutesToMap(){      
      this.rutasABASTOFiltradasParaMapa=[]
      this.getRoutes.forEach(item =>{
        this.setSelectedRoute(item, 0)
      })
      this.rutasABASTO = [...this.rutasABASTOFiltradasParaMapa]
      this.limpiaSeleccionMapa = true;
    },
    sendFilteredRoutesToMapOptimorum(){      
      this.rutasABASTOFiltradasParaMapaOptimorum=[]
      this.rutasABASTOFiltradasParaMapaOptimorumReal=[]
      
      this.getRoutesOptimorum.forEach(item =>{
        this.setSelectedRouteOptimorum(item, 0)
      })

      this.getRoutesOptimorumReal.forEach(item =>{
        this.setSelectedRouteOptimorumReal(item, 0)
      })
      
      this.rutasABASTOOptimorum = [...this.rutasABASTOFiltradasParaMapaOptimorum]
      this.rutasABASTOOptimorumReal = [...this.rutasABASTOFiltradasParaMapaOptimorumReal]
      this.limpiaSeleccionMapaOptimorum = true;
    },
    cancelSelectedRouteOptimorum(){
      this.selectedRouteOptimorum = {}
      this.rutasABASTOOptimorum=[]
      this.selectedRouteOptimorumReal = {}
      this.rutasABASTOOptimorumReal=[]
      this.limpiaSeleccionMapaOptimorum = false;
    },
    cancelSelectedRoute(){
      this.selectedRoute = {}
      this.rutasABASTO=[]
      this.limpiaSeleccionMapa = false;
    },
    numberWithCommas(n) {
      var parts = n.toString().split(".");
      return (
        parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (parts[1] ? "." + parts[1].substr(0, 2) : "")
      );
    },
    numberWithCommasND(n) {
      var parts = n.toString().split(".");
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    setSelectedKPI(kpi){
      this.selectedKpi = kpi

      if(kpi == 'pie'){
        this.chartDataPie.datasets[0].data=[0,0,0,0,0]        
        this.routes.forEach((route,index) =>{          
          this.chartDataPie.datasets[0].data[route.saltos-1]+=1
        })

      }
    },
    setSelectedRouteOptimorumReal(item, unique){
      let rutaItems= JSON.parse(JSON.stringify(item))
      /* rutaItems["puntos"]=[] //Agrega un nuevo campo
      
      item.cadena.forEach( (ubicacion,indice) =>{        
        if(this.cbOptimorum[ubicacion] !== undefined){          
          rutaItems.puntos.push({
            id: ubicacion,
              extra:{
                idsap: this.cbOptimorum[ubicacion].idsap                
              },
              nombre: this.cbOptimorum[ubicacion].descripcion,
              ubicacion:{
                lat: this.cbOptimorum[ubicacion].lat*1,
                lng: this.cbOptimorum[ubicacion].lng*1
              }
          })
        }        
      })

      if(rutaItems["puntos"].length<1){
        //No encontró cadena, se va a mandar al origen
        rutaItems.puntos.push({
          id: item.idOrigen,
            extra:{
              idsap: this.cbOptimorum[item.idOrigen].idsap                
            },
            nombre: this.cbOptimorum[item.idOrigen].descripcion,
            ubicacion:{
              lat: this.cbOptimorum[item.idOrigen].lat*1,
              lng: this.cbOptimorum[item.idOrigen].lng*1
            }
        })
      } */

      if(unique ==1 ){ //Esta seleccionando rutas 1 por 1
        this.rutasABASTOOptimorumReal=[rutaItems]
        this.selectedRouteOptimorumReal = item
        this.limpiaSeleccionMapaOptimorum = true;
      }
      else{
        this.rutasABASTOFiltradasParaMapaOptimorumReal.push(rutaItems)
      }
    },
    setSelectedRouteOptimorum(item, unique){
      let rutaItems= JSON.parse(JSON.stringify(item))
      /* rutaItems["puntos"]=[] //Agrega un nuevo campo
      
      item.cadena.forEach( (ubicacion,indice) =>{        
        if(this.cbOptimorum[ubicacion] !== undefined){          
          rutaItems.puntos.push({
            id: ubicacion,
              extra:{
                idsap: this.cbOptimorum[ubicacion].idsap                
              },
              nombre: this.cbOptimorum[ubicacion].descripcion,
              ubicacion:{
                lat: this.cbOptimorum[ubicacion].lat*1,
                lng: this.cbOptimorum[ubicacion].lng*1
              }
          })
        }        
      })

      if(rutaItems["puntos"].length<1){
        //No encontró cadena, se va a mandar al origen
        rutaItems.puntos.push({
          id: item.idOrigen,
            extra:{
              idsap: this.cbOptimorum[item.idOrigen].idsap                
            },
            nombre: this.cbOptimorum[item.idOrigen].descripcion,
            ubicacion:{
              lat: this.cbOptimorum[item.idOrigen].lat*1,
              lng: this.cbOptimorum[item.idOrigen].lng*1
            }
        })
      } */

      if(unique ==1 ){ //Esta seleccionando rutas 1 por 1
        this.rutasABASTOOptimorum=[rutaItems]
        this.selectedRouteOptimorum = item
        this.limpiaSeleccionMapaOptimorum = true;
      }
      else{
        this.rutasABASTOFiltradasParaMapaOptimorum.push(rutaItems)
      }
    },
    setSelectedRoute(item, unique){
      let rutaItems= JSON.parse(JSON.stringify(item))
      rutaItems["puntos"]=[] //Agrega un nuevo campo
      
      item.cadena.forEach( (ubicacion,indice) =>{        
        if(this.cb[ubicacion] !== undefined){          
          rutaItems.puntos.push({
            id: ubicacion,
              extra:{
                idsap: this.cb[ubicacion].idsap                
              },
              nombre: this.cb[ubicacion].descripcion,
              ubicacion:{
                lat: this.cb[ubicacion].lat*1,
                lng: this.cb[ubicacion].lng*1
              }
          })
        }        
      })

      if(unique ==1 ){ //Esta seleccionando rutas 1 por 1
        this.rutasABASTO=[rutaItems]
        this.selectedRoute = item
        this.limpiaSeleccionMapa = true;
      }
      else{
        this.rutasABASTOFiltradasParaMapa.push(rutaItems)
      }
    },
    loadFileOptimorum(){
      if (this.file.id) {
        let fr = new FileReader();
        let file = this.file.id
        let size = this.file.id.size        
        this.fileUploadedOptimorum = file.name+' '+ (size/1000)+'kb'
        if (size <= 50000000) {
          this.loading = true
          this.logError = []
          setTimeout(() => {
            fr.onload = () => {
              let data = XLSX.read(fr.result, { type: "array" })
              let sheetNames = data.SheetNames

              let numSheets = Object.keys(data.Sheets).length
              let worksheet
              let csv
              let values

              let expectedSheets= ['cat_plantas','cat_centrosBeneficio','cat_costoPromedioKm','Cemento','AbastosPlanOficial','EncadenadoPlanOficial','AbastosReal','EncadenadoReal']
              let pendingSheets = [...expectedSheets]
              let loadedSheets = [... expectedSheets]

              //Remueve las hojas de trabajo que si cargaron
              sheetNames.forEach((sheet,index) =>{
                pendingSheets = pendingSheets.filter(function(e) { return e !== sheet })
              })

              if(pendingSheets.length > 0){

                if(pendingSheets.toString().indexOf('cat_costoPromedioKm') > -1){
                  this.logError.push({
                    type:'WARNING -> Archivo Carga',
                    scenario:'Inicial', 
                    rowFile:0, 
                    detail: 'Archivo de carga incompleto, falta ' + pendingSheets.toString() + ' no se podrá completar rutas sin costo'
                  })
                  loadedSheets = loadedSheets.filter(function(e) { return e !== 'cat_costoPromedioKm' })
                }
                else{
                  this.loading = false
                  this.error = true
                  this.msgError = 'Archivo de carga incompleto, falta ' + pendingSheets.toString()
                  setTimeout(() => { this.error = false }, 5000);
                  return false
                }
              }

              let errorProceso = -1
              for(let x = 0; x < loadedSheets.length; x++){
                worksheet = data.Sheets[loadedSheets[x]]
                csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                values = Papa.parse(csv)
                if (values.data && values.data.length) {
                  values = values.data
                  if(loadedSheets[x] == 'cat_plantas'){ 
                    this.parsePlantCatalogOptimorum(values)
                  }
                  else if(loadedSheets[x] == 'cat_centrosBeneficio'){ 
                    this.parseCBOptimorum(values)
                    this.updatePlantMarkersOptimorum()
                  }
                  else if(loadedSheets[x] == 'cat_costoPromedioKm'){ 
                    this.parseCostoPromedio(values)
                  }
                  else if(loadedSheets[x] == 'Cemento'){
                    this.parseOptimorumCemento(values)
                  }
                  else if(loadedSheets[x] == 'AbastosPlanOficial'){
                    this.parseAbastos(values, 'planeado')
                  }
                  else if(loadedSheets[x] == 'EncadenadoPlanOficial'){
                    this.parseEncadenado(values,'planeado')
                  }
                  else if(loadedSheets[x] == 'AbastosReal'){
                    this.parseAbastos(values, 'real')
                  }
                  else if(loadedSheets[x] == 'EncadenadoReal'){
                    this.parseEncadenado(values,'real')
                  }
                }
                else {                  
                  errorProceso = x
                  break;
                }
              }
              
              if(errorProceso > -1){
                this.loading = false
                this.error = true
                this.msgError = 'El archivo '+ sheetNames[errorProceso] +' no fue leído correctamente'
                setTimeout(() => { this.error = false; errorProceso = -1 }, 2000);
                return false
              }              

              this.loading = false
            }
            fr.onerror = () => {
              this.loading = false
              this.file.id = null
              this.error = true
              this.msgError = 'El archivo no fue leído correctamente'
              setTimeout(() => { this.error = false }, 2000);
            }
            fr.readAsArrayBuffer(file);
          }, 1000);
        }
        else {
          this.error = true
          this.msgError = 'El archivo ha excedido el límite permitido (50 MB)'
          setTimeout(() => { this.error = false }, 2000);
        }
      }
        else {
        this.error = true
        this.msgError = 'Selecciona un archivo'
        setTimeout(() => { this.error = false }, 2000);
        this.routes = []
        this.fileUploadedOptimorum = ''
      }
    },
    loadFile() {
      if (this.file.id) {
        let fr = new FileReader();
        let file = this.file.id
        let size = this.file.id.size        
        this.fileUploaded = file.name+' '+ (size/1000)+'kb'
        if (size <= 50000000) {
          this.loading = true
          setTimeout(() => {
            fr.onload = () => {
              let data = XLSX.read(fr.result, { type: "array" })
              let sheetNames = data.SheetNames
              
              if(file.name.toLowerCase().indexOf("encadenamiento x hitos") === -1){
                let fileNOM = false
                let fileVentas = false
                let fileAbasto = false
                
                //Identifica que tipo de archivo es ABASTO, VENTAS o NOM
                if(data.SheetNames.find(element => element ==='relation')){
                  fileAbasto = true
                }
                else if(data.SheetNames.find(element => element ==='ventas')){
                  fileVentas = true
                }
                else{
                  fileNOM = true
                }

                let numSheets = Object.keys(data.Sheets).length
                let worksheet
                let csv
                let values

                if(numSheets >= 1){
                  worksheet = data.Sheets[sheetNames[0]]
                  csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                  values = Papa.parse(csv)
                  if (values.data && values.data.length) {
                    values = values.data
                    if(fileNOM || fileAbasto){ 
                      this.parsePlantCatalog(values)
                    }
                    else if(fileVentas){
                      this.parseMaterialVta(values)                    
                    }
                  }
                  else {
                    this.loading = false
                    this.error = true
                    this.msgError = 'El archivo no fue leído correctamente'
                    setTimeout(() => { this.error = false }, 2000);
                    return false
                  }
                }
                if(numSheets >= 2){
                  worksheet = data.Sheets[sheetNames[1]]
                  csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                  values = Papa.parse(csv)
                  if (values.data && values.data.length) {
                    values = values.data                
                    if(fileNOM){ 
                      this.parseAbastoNOM(values) 
                    }
                    else if(fileAbasto){ 
                      this.parseCB(values)
                      this.updatePlantMarkers()
                    }
                    else if(fileVentas){
                      this.parseSales(values)
                    }
                  }
                  else {
                    this.loading = false
                    this.error = true
                    this.msgError = 'El archivo no fue leído correctamente'
                    setTimeout(() => { this.error = false }, 2000);
                    return false
                  }
                }
                if(numSheets >= 3){
                  worksheet = data.Sheets[sheetNames[2]]
                  csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                  values = Papa.parse(csv)
                  if (values.data && values.data.length) {
                    values = values.data
                    if(fileNOM){ 
                      this.parseEntregasNOM(values) 
                    }
                    else if(fileAbasto){ 
                      this.parseCost(values)
                    }
                    
                  }
                  else {
                    this.loading = false
                    this.error = true
                    this.msgError = 'El archivo no fue leído correctamente'
                    setTimeout(() => { this.error = false }, 2000);
                    return false
                  }
                }
                if(numSheets >= 4){
                  worksheet = data.Sheets[sheetNames[3]]
                  csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                  values = Papa.parse(csv)
                  if (values.data && values.data.length) {
                    values = values.data
                    if(fileNOM){ 
                      this.parsePoligonosNOM(values)
                    }
                    else if(fileAbasto){ 
                      this.parseVehicle(values)
                    }                
                  }
                  else {
                    this.loading = false
                    this.error = true
                    this.msgError = 'El archivo no fue leído correctamente'
                    setTimeout(() => { this.error = false }, 2000);
                    return false
                  }
                }
                if(numSheets >= 5){
                  worksheet = data.Sheets[sheetNames[4]]
                  csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                  values = Papa.parse(csv)
                  if (values.data && values.data.length) {
                    values = values.data
                    if(fileAbasto){
                      this.parsePlantProduct(values)
                    }
                  }
                  else {
                    this.loading = false
                    this.error = true
                    this.msgError = 'El archivo no fue leído correctamente'
                    setTimeout(() => { this.error = false }, 2000);
                    return false
                  }
                }
                if(numSheets >= 6){
                  worksheet = data.Sheets[sheetNames[5]]
                  csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                  values = Papa.parse(csv)
                  if (values.data && values.data.length) {
                    values = values.data
                    if(fileAbasto){
                      this.parseYTDRoutes(values)
                    }
                  }
                  else {
                    this.loading = false
                    this.error = true
                    this.msgError = 'El archivo no fue leído correctamente'
                    setTimeout(() => { this.error = false }, 2000);
                    return false
                  }
                }
                if(numSheets >= 7){
                  worksheet = data.Sheets[sheetNames[6]]
                  csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                  values = Papa.parse(csv)
                  if (values.data && values.data.length) {
                    values = values.data
                    if(fileAbasto){
                      this.parseMaterialesCV(values)
                    }
                  }
                  else {
                    this.loading = false
                    this.error = true
                    this.msgError = 'El archivo no fue leído correctamente'
                    setTimeout(() => { this.error = false }, 2000);
                    return false
                  }
                }
                if(numSheets >= 8){
                  worksheet = data.Sheets[sheetNames[7]]
                  csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                  values = Papa.parse(csv)
                  if (values.data && values.data.length) {
                    values = values.data
                    if(fileAbasto){
                      this.parseCostoVariable(values)
                    }
                  }
                  else {
                    this.loading = false
                    this.error = true
                    this.msgError = 'El archivo no fue leído correctamente'
                    setTimeout(() => { this.error = false }, 2000);
                    return false
                  }
                }
                if(numSheets >= 9){
                  worksheet = data.Sheets[sheetNames[8]]
                  csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                  values = Papa.parse(csv)
                  if (values.data && values.data.length) {
                    values = values.data
                    this.routes=[]
                    if(fileAbasto){
                      this.parseRoutes(values)
                    }
                  }
                  else {
                    this.loading = false
                    this.error = true
                    this.msgError = 'El archivo no fue leído correctamente'
                    setTimeout(() => { this.error = false }, 2000);
                    return false
                  }
                }
              }
              else{
                let numSheets = Object.keys(sheetNames).length
                let worksheet
                let csv
                let values
                this.abastoMeses = {}
                this.abastoMesesAcum = {oDP:{},oDPTV:{}, oDPTVF:{}}
                this.itemsListMonths=[]

                //console.log(sheetNames)

                for(let i=0; i< numSheets; i++){
                  if(Object.keys(this.meses).find(element => element.toLowerCase() === sheetNames[i].toLowerCase())){
                    worksheet = data.Sheets[sheetNames[i]]
                    csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                    values = Papa.parse(csv)
                    if (values.data && values.data.length) {
                      values = values.data
                      this.itemsListMonths.push({text:sheetNames[i].toUpperCase(), value:this.meses[sheetNames[i].toUpperCase()]})
                      this.parseMonth(values,this.meses[sheetNames[i].toUpperCase()])
                    }
                    else {
                      this.loading = false
                      this.error = true
                      this.msgError = 'El archivo no fue leído correctamente'
                      setTimeout(() => { this.error = false }, 2000);
                      return false
                    }
                  }
                  else if(sheetNames[i].toLowerCase() === 'cat_plantas'){
                    worksheet = data.Sheets[sheetNames[i]]
                    csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                    values = Papa.parse(csv)
                    if (values.data && values.data.length) {
                      values = values.data
                      this.parsePlantCatalog(values)
                    }
                    else {
                      this.loading = false
                      this.error = true
                      this.msgError = 'El archivo no fue leído correctamente'
                      setTimeout(() => { this.error = false }, 2000);
                      return false
                    }
                  }
                  else if(sheetNames[i].toLowerCase() === 'cat_centrosbeneficio'){
                    worksheet = data.Sheets[sheetNames[i]]
                    csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                    values = Papa.parse(csv)
                    if (values.data && values.data.length) {
                      values = values.data
                      this.parseCB(values)
                    }
                    else {
                      this.loading = false
                      this.error = true
                      this.msgError = 'El archivo no fue leído correctamente'
                      setTimeout(() => { this.error = false }, 2000);
                      return false
                    }
                  }
                  else if(sheetNames[i].toLowerCase() === 'plant_product'){
                    worksheet = data.Sheets[sheetNames[i]]
                    csv = XLSX.utils.sheet_to_csv(worksheet).trim()
                    values = Papa.parse(csv)
                    if (values.data && values.data.length) {
                      values = values.data
                      this.parsePlantProduct(values)
                    }
                    else {
                      this.loading = false
                      this.error = true
                      this.msgError = 'El archivo no fue leído correctamente'
                      setTimeout(() => { this.error = false }, 2000);
                      return false
                    }
                  }
                }

              }
              this.loading = false
            }
            fr.onerror = () => {
              this.loading = false
              this.file.id = null
              this.error = true
              this.msgError = 'El archivo no fue leído correctamente'
              setTimeout(() => { this.error = false }, 2000);
            }
            fr.readAsArrayBuffer(file);
          }, 1000);
        }
        else {
          this.error = true
          this.msgError = 'El archivo ha excedido el límite permitido (50 MB)'
          setTimeout(() => { this.error = false }, 2000);
        }
      }
      else {
        this.error = true
        this.msgError = 'Selecciona un archivo'
        setTimeout(() => { this.error = false }, 2000);
        this.routes = []
        this.fileUploaded = ''
      }
    },
    parseSales(items){
      let costoODP = 0
      let findCB, findODP, destino, ruta, costoRuta, plantaDefault, plantaDefaultCosto, findODP2, ruta2, costoRuta2, esPlanta, plantaCB, costoCB, planta, costo

      for (let i = 1; i < items.length; i++) {
        let centro = items[i][0]
        let material = items[i][1].trim()
        planta = ''
        costo = ''

        if (!_.isNil(centro) && centro.trim() !== '' && !_.isNil(material) && material.trim() !== '') {
          
          findCB = this.findByMatchingProperties(Object.values(this.cb), {
            idsap: centro
          })
          destino = findCB.length>0 ? findCB[0].id : ''
          
          //Búsqueda 1: El destino es planta.
          esPlanta = destino != '' && this.cb[destino] ? 
                    (this.cb[destino].descripcion.toUpperCase().indexOf("PLANTA")> -1 || this.cb[destino].descripcion.toUpperCase().indexOf("PTA.")> -1)? 1 : 0 
                    : 0
          
          //Búsqueda 2 : Costo y Planta por destino y producto completo
          //console.log("material_abasto",material)
          findODP = destino != '' ? this.findByMatchingProperties(this.routes, {
            idDestino: destino,
            producto: this.materials[material].material_abasto
          }): []

                    
          //Selecciona el elemento con el volumen más alto
          ruta = findODP.length>0 ? findODP.reduce((prev, current) => (prev && (prev.volumenTramo*1) > (current.volumenTramo*1)) ? prev : current) : {}
          // antes buscaba costo this.cost[ruta.idOrigen+'_'+ruta.idDestino+'_'+ruta.producto]
          costoRuta = Object.keys(ruta).length > 0 ? ruta.costoRuta : 0

          //Busqueda 3 : Costo y Planta por destino y producto completo en el YTDRoutes
          let busca = true
          let origins = [destino]
          let planta3 = ''
          let costoRuta3 = 0          
          let volumenTotal= 0 //De los origenes cuanto % representa del total volumen
          while(busca){
            const findODPYTD = this.findByMatchingProperties(this.ytdRoutes, {
              idDestino: origins[0],
              producto: this.materials[material].material_abasto
            })
            //El arreglo de objetos lo convierte en arreglo de ids de los origenes
            const busquedaYTD = [...new Set(findODPYTD.map(a => a.idOrigen))];
            origins = origins.concat(busquedaYTD)

            //Revisa que algún origen encontrado sea planta y produzca mismo producto
            for(let x= 0; x < busquedaYTD.length; x++){
              if(_.has(this.plants, busquedaYTD[x])){
                if(this.plantProduct[busquedaYTD[x]+"_"+this.materials[material].material_abasto] !== undefined){ //Revisa que produzca esa planta ese producto
                  planta3 = ''+busquedaYTD[x];
                  
                  const finds = this.findByMatchingProperties(this.ytdRoutes, {
                    idDestino: destino,
                    producto: this.materials[material].material_abasto
                  })
                  costoRuta3 = 0
                  volumenTotal= finds.reduce((n, {volRuta}) => n + volRuta, 0)
                  //Saca el volumen ponderado de lo que encontró en histórico con el producto completo abasto
                  finds.forEach(a => {
                    costoRuta3 += a.costoRuta * (a.volRuta / volumenTotal)
                  })
                  break;
                }
              }
            }
            if(planta3 !== '' || origins.length < 1){
              busca = false
            }
            else{
              origins.shift();
            }
          }

          //Búsqueda 4: Costo y Planta por planta cualquier presentacion y material cualquier presentación
          /* //plantaDefault = this.defaultPlant[destino+"-"+this.materials[material].material_abasto_granel] ?? ''
          
          findODP2 = plantaDefault != '' ? this.findByMatchingProperties(this.routes, {
            planta: plantaDefault,
            producto: this.materials[material].material_abasto_granel
          }) : []
          ruta2 = findODP2.length>0 ? findODP2[0] : {}
                 
          costoRuta2 = Object.keys(ruta2).length > 0 && this.cost[ruta2.idOrigen+'_'+ruta2.idDestino+'_'+ruta2.producto] ? this.cost[ruta2.idOrigen+'_'+ruta2.idDestino+'_'+ruta2.producto] : 0 */

          busca = true
          origins = [destino]
          let planta4 = ''
          let costoRuta4 = 0
          volumenTotal= 0
          while(busca){
            const findsyd = this.findByMatchingProperties(this.ytdRoutes, {
              idDestino: origins[0],
              producto: this.materials[material].material_abasto_granel
            })
            //El arreglo de objetos lo convierte en arreglo de ids de los origenes
            const busqueda = [...new Set(findsyd.map(a => a.idOrigen))];
            origins = origins.concat(busqueda)

            //Revisa que algún origen encontrado sea planta y produzca mismo producto
            for(let x= 0; x < busqueda.length; x++){
              if(_.has(this.plants, busqueda[x])){
                if(this.plantProduct[busqueda[x]+"_"+this.materials[material].material_abasto_granel] !== undefined){ //Revisa que produzca esa planta ese producto
                  planta4 = ''+busqueda[x];
                  
                  const finds = this.findByMatchingProperties(this.ytdRoutes, {
                    idDestino: destino,
                    producto: this.materials[material].material_abasto_granel
                  })
                  costoRuta4 = 0
                  volumenTotal= finds.reduce((n, {volRuta}) => n + volRuta, 0)
                  //Saca el volumen ponderado de lo que encontró en histórico con el producto completo abasto granel
                  finds.forEach(a => {
                    costoRuta4 += a.costoRuta * (a.volRuta / volumenTotal)
                  })
                  /* finds.forEach(a => {
                    costoRuta4 += (a.costoRuta*1)
                  })
                  costoRuta4 = costoRuta4 / finds.length */

                  break;
                }
              }
            }
            if(planta4 !== '' || origins.length < 1){
              busca = false
            }
            else{
              origins.shift();
            }
          }

          //plantaCB = ruta.planta ? ruta.planta : esPlanta > 0 ? centro : plantaDefault ? plantaDefault : ''
          /* if(destino == '141700' && material == 'GRIS CPC 40 GRANEL'){
            console.log(this.plantProduct, this.plantProduct[destino+"_"+this.materials[material].material_abasto],centro)
          } */
          plantaCB = (esPlanta > 0 && this.plantProduct[destino+"_"+this.materials[material].material_abasto] !== undefined)? centro : 
          ruta.planta ? ruta.planta : 
          planta3 ? planta3 : 
          planta4 ? planta4 : ''
          
          planta = plantaCB != '' && !isNaN(plantaCB) ? this.cb[plantaCB].idsap : plantaCB
          
          /*
          costo = (esPlanta > 0 && this.plantProduct[destino+"_"+this.materials[material].material_abasto] !== undefined) ? 1 : 
          ruta.planta !== '' && costoRuta > 0 ? costoRuta : 
          planta3 !== '' && costoRuta3 > 0 ? costoRuta3: 
          planta4 !== '' && costoRuta4 > 0 ? costoRuta4 : 0
          */
          costo = (esPlanta > 0 && this.plantProduct[destino+"_"+this.materials[material].material_abasto] !== undefined) ? 1 : 
          ruta.planta ? costoRuta : 
          planta3 ? costoRuta3: 
          planta4 ? costoRuta4 : 0


          this.sales.push({ centro, material, cb:destino, esPlanta,
            plantaB1: centro, costoB1: 1,
            plantaB2: (ruta.planta??''), costoB2: costoRuta,
            plantaB3: planta3, costoB3: costoRuta3,
            plantaB4: planta4, costoB4: costoRuta4,
            /* plantaB1: (ruta.planta??''), costoB1: costoRuta,
            plantaB2: plantaDefault, costoB2: costoRuta2,
            plantaB3: centro, costoB3: 1, */
            plantaCB,
            planta, costo })
        }
      }
      /* console.log("Sales", this.sales)
      console.log("Routes", this.routes)
      console.log("Planta Default", this.defaultPlant) */
    },
    parseMaterialVta(items){
      let material, material_abasto,material_abasto_granel,key
      for (let i = 1; i < items.length; i++) {
        material = items[i][0]
        material_abasto = items[i][1]
        material_abasto_granel = items[i][2]
        if (!_.isNil(material) && material.trim() !== '' && !_.isNil(material_abasto) && material_abasto.trim() !== '' && !_.isNil(material_abasto_granel) && material_abasto_granel.trim() !== '') {
          key = material.trim()
          this.materials[key]= { material_abasto, material_abasto_granel }
        }
      }
    },
    parsePlantCatalogOptimorum(items) {
      for (let i = 1; i < items.length; i++) {
        let planta = items[i][0]
        if (!_.isNil(planta) && planta.trim() !== '') {
          let key = planta.trim()          
          this.plantsOptimorum[key]= { id: items[i][0], nombre: items[i][1], idsap: items[i][2], costo: items[i][3], lat:items[i][4],lon:items[i][5]}          
        }
      }
      this.updatePlantMarkersOptimorum()
    },
    updatePlantMarkersOptimorum(){
      this.marcadoresPlantaOptimorum = []
      let plantasId = Object.keys(this.plantsOptimorum)      
      for(let i=0; i< plantasId.length; i++){
        if(this.plantsOptimorum && this.plantsOptimorum[plantasId[i]]){          
          this.marcadoresPlantaOptimorum.push({
            id: this.plantsOptimorum[plantasId[i]].id,
            extra:{
              idsap: this.cbOptimorum[this.plantsOptimorum[plantasId[i]].id]? this.cbOptimorum[this.plantsOptimorum[plantasId[i]].id].idsap:''
            },
            nombre: this.plantsOptimorum[plantasId[i]].nombre,
            ubicacion:{
              lat: this.plantsOptimorum[plantasId[i]].lat*1,
              lng: this.plantsOptimorum[plantasId[i]].lon*1
            },
          })
        }
      }
    },
    parseCBOptimorum(items) {
      this.cbOptimorum = {}
      for (let i = 1; i < items.length; i++) {
        let cb = items[i][0]
        if (!_.isNil(cb) && cb.trim() !== '') {
          let key = cb.trim()
          this.cbOptimorum[key]={ 
            id:items[i][0], idsap:items[i][1], descripcion:items[i][2], lat:items[i][3], lng:items[i][4] 
          }
        }
      }
    },
    parsePlantCatalog(items) {
      for (let i = 1; i < items.length; i++) {
        let planta = items[i][0]
        if (!_.isNil(planta) && planta.trim() !== '') {
          let key = planta.trim()          
          this.plants[key]= { id: items[i][0], nombre: items[i][1], idsap: items[i][2], costo: items[i][3], lat:items[i][4],lon:items[i][5]}
        }
      }
      this.updatePlantMarkers()
    },
    updatePlantMarkers(){
      this.marcadoresPlanta = []
      let plantasId = Object.keys(this.plants)      
      for(let i=0; i< plantasId.length; i++){
        if(this.plants && this.plants[plantasId[i]]){          
          this.marcadoresPlanta.push({
            id: this.plants[plantasId[i]].id,
            extra:{
              idsap: this.cb[this.plants[plantasId[i]].id]?this.cb[this.plants[plantasId[i]].id].idsap:''
            },
            nombre: this.plants[plantasId[i]].nombre,
            ubicacion:{
              lat: this.plants[plantasId[i]].lat*1,
              lng: this.plants[plantasId[i]].lon*1
            },
          })
        }
      }
    },
    parseCB(items) {
      for (let i = 1; i < items.length; i++) {
        let cb = items[i][0]
        if (!_.isNil(cb) && cb.trim() !== '') {
          let key = cb.trim()
          this.cb[key]={ 
            id:items[i][0], idsap:items[i][1], descripcion:items[i][2], lat:items[i][3], lng:items[i][4] 
          }
        }
      }
    },
    parseCost(items) {
      for (let i = 1; i < items.length; i++) {
        let costo = items[i][0]
        if (!_.isNil(costo) && costo.trim() !== '') {
          let key = costo.trim()
          this.cost[key]=items[i][1]
          this.costSegment[key]=items[i][2]
        }
      }      
    },
    parseVehicle(items) {
      for (let i = 1; i < items.length; i++) {
        let origen = items[i][0]
        let destino = items[i][1]
        let producto = items[i][2]
        let transporte = items[i][3]
        let vehiculo = items[i][4]
        let tonAbasto = items[i][5]
        let fleteAbasto = items[i][6]
        let tonParaVta = items[i][7]
        let fleteParaVta = items[i][8]

        if (!_.isNil(origen) && origen.trim() !== '' && !_.isNil(destino) && destino.trim() !== '' && !_.isNil(producto) && producto.trim() !== '' && !_.isNil(transporte) && transporte.trim() !== '' && !_.isNil(vehiculo) && vehiculo.trim() !== '') {
          this.vehicle.push({idOrigen: origen, idDestino: destino, producto, transporte, vehiculo, tonAbasto, fleteAbasto, tonParaVta, fleteParaVta})
        }
      }
    },
    parsePlantProduct(items){
      let relPP = {}
      for (let i = 1; i < items.length; i++) {
        //console.log(items[i][0]+"_"+items[i][1])
        relPP[items[i][0]+"_"+items[i][1]]=i
      }
      this.plantProduct = JSON.parse(JSON.stringify(relPP))
    },
    parseYTDRoutes(items){      
      for (let i = 1; i < items.length; i++) {        
        this.ytdRoutes.push({ 
          idOrigen: items[i][0], 
          idDestino: items[i][1], 
          producto: items[i][2],
          transporte: items[i][3],
          vehiculo: items[i][4],
          volTramo: items[i][5]*1,
          costoTramo: items[i][6]*1,
          volRuta: items[i][7]*1,
          costoRuta: items[i][8]*1,
        })
      }      
    },
    parseMaterialesCV(items){      
      for (let i = 1; i < items.length; i++) {        
        this.materialesCV.push({ 
          matAbasto: items[i][0],
          matGranel: items[i][1],
          categoria: items[i][2],
          categoria2: items[i][3],
          gpo: items[i][4],
          grupo: items[i][5],
        })
      }      
    },
    parseCostoVariable(items){      
      for (let i = 1; i < items.length; i++) {        
        this.costoVariable.push({ 
          keyAbasto: items[i][0], 
          plantaAbasto: items[i][1], 
          key: items[i][2],
          gpo: items[i][3],
          grupo: items[i][4],
          planta: items[i][5],
          plantaDesc: items[i][6],
          costo: items[i][7]*1
        })
      }      
    },
    parseMonth(items, month) {
            
      //oDP: origen-destino-producto
      //oDPTV: origen-destino-producto-transporte-vehiculo
      //oDPTVF: origen-destino-producto-transporte-vehiculo-fletero
      let tempAbastoMeses = {}
      tempAbastoMeses[month] = {oDP:{},oDPTV:{}, oDPTVF:{}}

      let colAbasto ={
        "Negocio":0,
        "Base":1,
        "Año":2,
        "Mes":3,
        "Acum":4,
        "Hito":5,
        "IdRed":6,
        "Red":7,
        "Destino#":8,
        "Destino":9,
        "AgrupProducto":10,
        "GrsProducto":11,
        "ProdGroup":12,
        "DescrProducto":13,
        "Transporte":14,
        "Renta":15,
        "Vehiculo":16,
        "TiFletero":17,
        "Conexion":18,
        "Origen#":19,
        "Origen":20,
        "CP":21,
        "AbastecidasDestino":22,
        "Flete":23,
        "ToneladasDestinoAbasto":24,
        "AbastoParaVenta":25,
        "FleteEncadenado":26
      }

      items.forEach( (item,index) =>{
        
        let llaveODP = item[colAbasto["Origen#"]] + '_' + item[colAbasto["Destino#"]] + '_' + item[colAbasto["DescrProducto"]]
        let llaveODPTV = llaveODP + '_' + item[colAbasto["Transporte"]] + '_' + item[colAbasto["Vehiculo"]]
        let llaveODPTVF = llaveODPTV + '_' + item[colAbasto["TiFletero"]]
        
        if(index > 0){ //Para todos los renglones menos para el primero que tiene los nombres de las columnas
          
          /*************** INICIO ******************/
          let llaves = [llaveODP, llaveODPTV, llaveODPTVF]
          let estructuras = ["oDP","oDPTV","oDPTVF"]
          let llave = ""
          let estructura = ""
          while(llaves.length > 0){
            
            llave= llaves.shift()
            estructura = estructuras.shift()
            
            //Inicializa el objecto para el mes que se está procesando
            if(!tempAbastoMeses[month][estructura][llave]){
              tempAbastoMeses[month][estructura][llave] = {
                volTramoArr:[],volVtaArr:[],fleteTramoArr:[],fleteVtaArr:[], costoTramo:0, costoVta:0,volTramo:0,volVta:0,fleteTramo:0,fleteVta:0
              }
            }
            
            //Para TRAMO
            if( !tempAbastoMeses[month][estructura][llave].volTramoArr.find(element => element === item[colAbasto["AbastecidasDestino"]]) ||
                !tempAbastoMeses[month][estructura][llave].fleteTramoArr.find(element => element === item[colAbasto["Flete"]])
              ){
              tempAbastoMeses[month][estructura][llave].volTramoArr.push(item[colAbasto["AbastecidasDestino"]])
              tempAbastoMeses[month][estructura][llave].fleteTramoArr.push(item[colAbasto["Flete"]])
              tempAbastoMeses[month][estructura][llave].volTramo = Math.round((tempAbastoMeses[month][estructura][llave].volTramoArr.reduce((partialSum, a) => Number(partialSum) + Number(a), 0))*100)/100
              tempAbastoMeses[month][estructura][llave].fleteTramo = Math.round((tempAbastoMeses[month][estructura][llave].fleteTramoArr.reduce((partialSum, a) => Number(partialSum) + Number(a), 0))*100)/100
            }
            
            //Para VENTA
            if( !tempAbastoMeses[month][estructura][llave].volVtaArr.find(element => element === item[colAbasto["AbastoParaVenta"]]) ||
                !tempAbastoMeses[month][estructura][llave].fleteVtaArr.find(element => element === item[colAbasto["FleteEncadenado"]])
              ){
              tempAbastoMeses[month][estructura][llave].volVtaArr.push(item[colAbasto["AbastoParaVenta"]])
              tempAbastoMeses[month][estructura][llave].fleteVtaArr.push(item[colAbasto["FleteEncadenado"]])
              tempAbastoMeses[month][estructura][llave].volVta = Math.round((tempAbastoMeses[month][estructura][llave].volVtaArr.reduce((partialSum, a) => Number(partialSum) + Number(a), 0))*100)/100
              tempAbastoMeses[month][estructura][llave].fleteVta = Math.round((tempAbastoMeses[month][estructura][llave].fleteVtaArr.reduce((partialSum, a) => Number(partialSum) + Number(a), 0))*100)/100
            }

            tempAbastoMeses[month][estructura][llave].costoTramo = Math.round((tempAbastoMeses[month][estructura][llave].fleteTramo / tempAbastoMeses[month][estructura][llave].volTramo)*100)/100
            tempAbastoMeses[month][estructura][llave].costoVta = Math.round((tempAbastoMeses[month][estructura][llave].fleteVta / tempAbastoMeses[month][estructura][llave].volVta)*100)/100


            //Inicializa el objecto ACUM para el mes que se está procesando
            if(!this.abastoMesesAcum[estructura][llave]){
              this.abastoMesesAcum[estructura][llave] = {
                costoTramo:0, costoVta:0, volTramo:0, volVta:0, fleteTramo:0, fleteVta:0, 1:{},2:{},3:{},4:{},5:{},6:{},7:{},8:{},9:{},10:{},11:{},12:{}
              }
            }
          }
          /*************** FIN ******************/          
        }
      })
      this.abastoMeses[month] = JSON.parse(JSON.stringify(tempAbastoMeses[month]))

      /*** Actualiza ACUM Inicio ***/      
      let estructuras = ["oDP","oDPTV","oDPTVF"]      
      let estructura = ""
      while(estructuras.length > 0){
        estructura = estructuras.shift()

        Object.keys(tempAbastoMeses[month][estructura]).forEach( llave =>{
          //Para TRAMO
          this.abastoMesesAcum[estructura][llave].volTramo = Math.round((this.abastoMesesAcum[estructura][llave].volTramo + tempAbastoMeses[month][estructura][llave].volTramo)*100)/100
          this.abastoMesesAcum[estructura][llave].fleteTramo = Math.round((this.abastoMesesAcum[estructura][llave].fleteTramo + tempAbastoMeses[month][estructura][llave].fleteTramo)*100)/100
          
          //Para VENTA
          this.abastoMesesAcum[estructura][llave].volVta = Math.round((this.abastoMesesAcum[estructura][llave].volVta + tempAbastoMeses[month][estructura][llave].volVta)*100)/100
          this.abastoMesesAcum[estructura][llave].fleteVta = Math.round((this.abastoMesesAcum[estructura][llave].fleteVta + tempAbastoMeses[month][estructura][llave].fleteVta)*100)/100

          this.abastoMesesAcum[estructura][llave].costoTramo = Math.round((this.abastoMesesAcum[estructura][llave].fleteTramo / this.abastoMesesAcum[estructura][llave].volTramo)*100)/100
          this.abastoMesesAcum[estructura][llave].costoVta = Math.round((this.abastoMesesAcum[estructura][llave].fleteVta / this.abastoMesesAcum[estructura][llave].volVta)*100)/100
          this.abastoMesesAcum[estructura][llave][month]= tempAbastoMeses[month][estructura][llave]
        })            
      }
      /*** Actualiza ACUM Fin ***/
    },    
    parseRoutes(items) {
      let listadoUnicos = {}
      let listadoUnicoProductos ={}
      let tempItemsList = []
      let tempItemsListProducto = []

      for (let i = 1; i < items.length; i++) {
        let origen = items[i][0]
        let destino = items[i][1]
        let producto = items[i][2]
        let volumen = items[i][3]
        let volumenTramo = items[i][4]

        let distancia = 0
        let origin = this.cb[origen]?{lat: this.cb[origen].lat*1, lng:this.cb[origen].lng*1}:{lat:0,lng:0}
        let destiny = this.cb[destino]?{lat: this.cb[destino].lat*1, lng:this.cb[destino].lng*1}:{lat:0,lng:0}

        if(!(origin.lat==0 || origin.lng==0 || destiny.lat==0 || destiny.lng==0)){
          distancia = this.haversine_distance(origin,destiny)*1
        }
        
        let costoRuta = this.cost[origen+"_"+destino+"_"+producto] ?? 0
        let costoTramo = this.costSegment[origen+"_"+destino+"_"+producto] ?? 0

        const findVehicle = this.findByMatchingProperties(this.vehicle, {
          idOrigen:  origen,
          idDestino: destino,
          producto: producto
        })
                  
        const vehiculos = [...new Set(findVehicle.map(a => a.vehiculo))].join('|').trim()
        const transportes = [...new Set(findVehicle.map(a => a.transporte))].join('|').trim()
        
        const costoTramoKm = distancia < 1 ? -1 : this.numberWithCommas(costoTramo / distancia)

        const origenNombre = (this.cb[origen]? this.cb[origen].descripcion : origen)
        const destinoNombre = (this.cb[destino]? this.cb[destino].descripcion : destino)

        if (!_.isNil(origen) && origen.trim() !== '' && !_.isNil(destino) && destino.trim() !== '' && !_.isNil(producto) && producto.trim() !== '') {
          this.routes.push({renglon:(i+1),idOrigen: origen, idDestino: destino, producto, cadena:[], cadenaNombres:[], cadenaCosto:[], cadenaCostoTramo:[], cadenaAcumCosto:[], planta:'', costoProduccion:0, cadenaProducto:[], prodDif:0, saltos:0, cadenaVehiculo:[], volumen, volumenTramo, cadenaVolumenTramo:[],cadenaVolumen:[], cadenaTransporte:[], cadenaDistancias:[], distancia, costoTramo, costoRuta, transporteTramo: transportes, vehiculoTramo: vehiculos, costoTramoKm, origenNombre, destinoNombre})
        }
        listadoUnicos[origen]=1
        listadoUnicos[destino]=1
        listadoUnicoProductos[producto]=1
      }

      let tempListKeys = Object.keys(listadoUnicos)
      tempListKeys.forEach(entry =>{
        if(this.cb[entry]){          
          tempItemsList.push({ text:entry+' '+this.cb[entry].idsap+' '+this.cb[entry].descripcion, value: entry, descripcion: this.cb[entry].descripcion})
        }
      })
      tempItemsList.sort(function(a,b){
        if (!isNaN(parseFloat(a.descripcion)) && !isNaN(parseFloat(b.descripcion))){
          return b.descripcion - a.descripcion;
        }
        else{
          if ( a.descripcion < b.descripcion ) return -1;
          if ( a.descripcion > b.descripcion ) return 1;
          return 0;
        }
      });      
      this.itemsList = [...tempItemsList]
      this.itemsListDestino = [...tempItemsList]
      this.itemsListPlantaProd = tempItemsList.filter( elem => elem.descripcion.toUpperCase().indexOf("PLANTA")> -1 || elem.descripcion.toUpperCase().indexOf("PTA.")> -1)
      this.itemsListPlantaProd.unshift({ text:'SIN PLANTA', value: '', descripcion: ''})

      let tempListKeysProductos = Object.keys(listadoUnicoProductos)
      tempListKeysProductos.forEach(entry =>{
        tempItemsListProducto.push({ text:entry, value: entry, descripcion: entry })
      })
      tempItemsListProducto.sort(function(a,b){
        if (!isNaN(parseFloat(a.descripcion)) && !isNaN(parseFloat(b.descripcion))){
          return b.descripcion - a.descripcion;
        }
        else{
          if ( a.descripcion < b.descripcion ) return -1;
          if ( a.descripcion > b.descripcion ) return 1;
          return 0;
        }
      });      
      this.itemsListProducto = [...tempItemsListProducto]      

      this.buildFullRoute(this.routes,[],[],[])
      this.findDefaultPlant()
      //console.log(this.defaultPlant)
      
    },
    parseAbastoNOM(items) {
      this.abastoNOM=[]
      for (let i = 1; i < items.length; i++) {
        let origen = items[i][0]
        let destino = items[i][1]
        let volumen = items[i][2]
        let lat_origen = items[i][3]
        let lng_origen = items[i][4]
        let lat_destino = items[i][5]
        let lng_destino = items[i][6]
        let nombre_origen = items[i][7]
        let nombre_destino = items[i][8]
        
        if (!_.isNil(origen) && origen.trim() !== '' && !_.isNil(destino) && destino.trim() !== '' && !_.isNil(volumen) && volumen.trim() !== '' ) {
          this.abastoNOM.push({idOrigen: origen, idDestino: destino, volumen,lat_origen,lng_origen,lat_destino,lng_destino,nombre_origen,nombre_destino})
        }
      }
    },
    parseEntregasNOM(items) {
      this.entregasNOM=[]
      for (let i = 1; i < items.length; i++) {
        let origen = items[i][0]
        let destino = items[i][1]
        let volumen = items[i][2]
        let lat_origen = items[i][3]
        let lng_origen = items[i][4]
        let lat_destino = items[i][5]
        let lng_destino = items[i][6]
        let nombre_origen = items[i][7]
        let nombre_destino = items[i][8]
        
        if (!_.isNil(origen) && origen.trim() !== '' && !_.isNil(destino) && destino.trim() !== '' && !_.isNil(volumen) && volumen.trim() !== '' ) {
          this.entregasNOM.push({idOrigen: origen, idDestino: destino, volumen,lat_origen,lng_origen,lat_destino,lng_destino,nombre_origen,nombre_destino})
        }
      }
    },
    parsePoligonosNOM(items) {
      this.poligonosNOM=[]
      for (let i = 1; i < items.length; i++) {
        let idPoligono = items[i][0]
        let nombre = items[i][1]
        let color = items[i][2]
        let path = items[i][3]
        let tipo = items[i][4]
        
        if (!_.isNil(idPoligono) && idPoligono.trim() !== '' && !_.isNil(nombre) && nombre.trim() !== '' && !_.isNil(path) && path.trim() !== '' ) {
          this.poligonosNOM.push({idPoligono, nombre, color, path, tipo})
        }
      }
      //console.log("poligonos", this.poligonosNOM)
    },
    findDefaultPlant(){
      // Busca para cada destino-producto una planta default, 
      // en la búsqueda si hay más de 1 opción selecciona la que tiene mayor volumen
      // y para el producto lo busca sin presentación
      for(let index=0; index< this.routes.length; index++){

        let tempProducto = (this.routes[index].producto.lastIndexOf(" ") > 0 ? this.routes[index].producto.substring(0, this.routes[index].producto.lastIndexOf(" ")) : this.routes[index].producto)
        
      //if(this.routes[index].idDestino === '141201' && this.routes[index].producto === 'CPC 50k'){
        let busca=1
        let tempDestino = this.routes[index].idDestino
        while(busca > 0){

          const opciones = this.findByDestinyProduct(this.routes,{
            idDestino: tempDestino,
            producto: tempProducto
          })
          //console.log('opciones',opciones)
          
          if(opciones.length > 0){
            const max = opciones.reduce(function(prev, current) {
                return (prev && (prev.volumen*1) > (current.volumen*1)) ? prev : current
            }) //returns object

            
            if(_.has(this.plants, max.idOrigen)){
              this.defaultPlant[max.idDestino+'-'+tempProducto]= max.idOrigen
              busca=0
            }
            else{
              tempDestino = max.idOrigen
            }
          }
          else{
            busca=0
          }
        }
      //}

      }
    },
    buildFullRoute(pRoutes, originChain, productChain, level) {

      for(let index=0; index< pRoutes.length; index++){
        let planta = ''
        let deTabla= 0

        
        //Encuentra combinaciones Origen-Destino-Producto del origen como destino
        const findODP = this.findByMatchingProperties(this.routes, {
          idDestino: pRoutes[index].idOrigen,
          producto: pRoutes[index].producto
        })

        //Selecciona el elemento con el volumen más alto
        findODP = findODP.length > 0 ? [findODP.reduce((prev, current) => (prev && (prev.volumenTramo*1) > (current.volumenTramo*1)) ? prev : current)] : []
        
        

        //El arreglo de objetos lo convierte en arreglo de ids de los origenes
        const busqueda = [...new Set(findODP.map(a => a.idOrigen))];

        //Revisa que algún origen encontrado sea planta y produzca mismo producto
        for(let indiceB= 0; indiceB < busqueda.length; indiceB++){
          if(_.has(this.plants, busqueda[indiceB])){
            if(this.plantProduct[busqueda[indiceB]+"_"+pRoutes[index].producto] !== undefined){ //Revisa que produzca esa planta ese producto
              planta = ''+busqueda[indiceB];
              break;
            }
          }
        }

        

        //Si Origen-Producto están en la tabla, salió de ese origen, asignando como planta productora
        if(this.plantProduct[pRoutes[index].idOrigen+"_"+pRoutes[index].producto] !== undefined){          
          planta = pRoutes[index].idOrigen
          deTabla = 1
        }

        /* //Encuentra combinaciones Origen-Destino-Producto del origen como destino en YTDRoutes
        if(planta === ''){ //Si aún no encuentra planta
          let busca = true
          let origins = [pRoutes[index].idOrigen]
          while(busca){
            const findODPYTD = this.findByMatchingProperties(this.ytdRoutes, {
              idDestino: origins[0],
              producto: pRoutes[index].producto
            })
            //El arreglo de objetos lo convierte en arreglo de ids de los origenes
            const busquedaYTD = [...new Set(findODPYTD.map(a => a.idOrigen))];
            origins = origins.concat(busquedaYTD)

            //Revisa que algún origen encontrado sea planta y produzca mismo producto
            for(let x= 0; x < busquedaYTD.length; x++){
              if(_.has(this.plants, busquedaYTD[x])){
                if(this.plantProduct[busquedaYTD[x]+"_"+pRoutes[index].producto] !== undefined){ //Revisa que produzca esa planta ese producto
                  planta = ''+busquedaYTD[x];
                  break;
                }
              }
            }
            if(planta !== '' || origins.length < 1){
              busca = false
            }
            else{
              origins.shift();
            }
          }
        } */
        
        if(planta !== ''){ //Si encontró planta
          //Si está en el nivel de búsqueda mayor al inicial
          /* if(level.length > 0){
            //Agrega el origen de pRoutes a la cadena de busqueda
            originChain.push(''+pRoutes[index].idOrigen);
            productChain.push(''+pRoutes[index].producto);
          } */
          
          //Si lo encontró del listado y no está en un nivel inicial
          // guardas el destino intermedio entre la planta y el origen que se busco como destino
          if(deTabla < 1 && level.length > 0){
            originChain.push(''+pRoutes[index].idOrigen);
          }
          //Guarda el producto en la cadena de productos
          productChain.push(''+pRoutes[index].producto);
          //Agrega la planta encontrada
          originChain.push(planta);
          
          //Agrega la planta encontrada
          //if(planta != -1000){ //Este if se agregó para cuando la planta esta en tabla plantaproducto
          //originChain.push(planta);
          //}
        }
        else{ //Si no encontró planta
          
          //Si está en un nivel de búsqueda mayor al inicial
          //guardas el destino y el producto que se busco intermedio
          if(level.length > 0){
            //Agrega el origen de pRoutes a la cadena de busqueda
            originChain.push(''+pRoutes[index].idOrigen);
            productChain.push(''+pRoutes[index].producto);
          }
                    
          //Actualiza el nivel de búsqueda +1
          level.push(1);
                        
          if(findODP.length > 0){ //Si hay listado de origenes
            //sigue buscando planta, pero ahora de ese listado
            this.buildFullRoute(findODP, originChain, productChain, level);
          }          
          /* else{ //Si no hay opciones, busca con producto más general - sin presentación
            const findODP2 = this.findByMatchingProperties(this.routes, {
              idDestino: pRoutes[index].idOrigen,
              producto: pRoutes[index].producto.substring(0, pRoutes[index].producto.lastIndexOf(" "))
            })
            this.buildFullRoute(findODP2, originChain, productChain, level);
          } */
          //Cuando termina, actualiza nivel -1
          level.pop();
        }

        //Esta en el nivel inicial
        if(level.length < 1){
          
          //Encuentra y recorta cadena al encontrar la primera planta
          let tempCombinado=[]
        
          for(let w=0; w < originChain.length; w++){
            tempCombinado.push(originChain[w])

            if(_.has(this.plants, originChain[w])){
              //console.log(originChain[w]+"_"+pRoutes[index].producto)
              if(this.plantProduct[originChain[w]+"_"+pRoutes[index].producto] !== undefined){
                pRoutes[index].planta = originChain[w]
                pRoutes[index].costoProduccion = this.getVariableCost(originChain[w], pRoutes[index].producto) //this.plants[originChain[w]].costo
                break;
              }
              //else{
              //  tempCombinado.pop()                
              //}
            }
          }

          //Actualiza originChain y productChain con el recorte
          originChain = [...tempCombinado]
          productChain = productChain.slice(0,tempCombinado.length)

          //Mete la ruta original con la que inició la búsqueda
          if(deTabla < 1){
            originChain.unshift(''+pRoutes[index].idDestino,''+pRoutes[index].idOrigen);
            productChain.unshift(pRoutes[index].producto)
          }
          else{
            originChain.unshift(''+pRoutes[index].idDestino);
          }

          //Actualiza en pRoutes la cadena
          //console.log('finalChains:'+index+'.-',originChain, productChain)
          pRoutes[index].cadena = JSON.parse(JSON.stringify(originChain));
          pRoutes[index].cadenaProducto = JSON.parse(JSON.stringify(productChain));

          /*** Inicia rescate ***/
          // Ya no encontró planta buscando encadenado
          // Pero si el origen inicial es planta, la toma como su origen
          /* if(pRoutes[index].planta === ''){
            if(_.has(this.plants, this.routes[index].idOrigen)){
              if(this.plantProduct[this.routes[index].idOrigen+"_"+this.routes[index].producto] !== undefined){
                this.routes[index].planta = ''+this.routes[index].idOrigen;
                this.routes[index].costoProduccion = this.plants[this.routes[index].idOrigen].costo
              }
            }
          } */
          //Encuentra combinaciones Origen-Destino-Producto del origen como destino en YTDRoutes
          if(pRoutes[index].planta === ''){ //Si aún no encuentra planta
            let busca = true
            let origins = [this.routes[index].idOrigen]
            let brincos = 0 //puse esta variable porque se quedaba en un ciclo cuando no había ciclo en el histórico
            while(busca){              
              brincos+=1
              const findODPYTD = this.findByMatchingProperties(this.ytdRoutes, {
                idDestino: origins[0],
                producto: this.routes[index].producto
              })
              //El arreglo de objetos lo convierte en arreglo de ids de los origenes
              const busquedaYTD = [...new Set(findODPYTD.map(a => a.idOrigen))];
              origins = origins.concat(busquedaYTD)

              //Revisa que algún origen encontrado sea planta y produzca mismo producto
              for(let x= 0; x < busquedaYTD.length; x++){
                if(_.has(this.plants, busquedaYTD[x])){
                  if(this.plantProduct[busquedaYTD[x]+"_"+this.routes[index].producto] !== undefined){ //Revisa que produzca esa planta ese producto
                    planta = ''+busquedaYTD[x];
                    this.routes[index].planta = planta;
                    this.routes[index].costoProduccion = this.getVariableCost(planta, this.routes[index].producto)//this.plants[busquedaYTD[x]].costo
                    break;
                  }
                }
              }
              if(planta !== '' || origins.length < 1 || brincos >= 7){
                busca = false
              }
              else{
                origins.shift();
              }
            }
          }

          /* if(pRoutes[index].planta === ''){ //Si aún no encuentra planta BUSCA CON GRANEL
            let busca = true
            let origins = [this.routes[index].idOrigen]
            let product = this.routes[index].producto.substring(0, this.routes[index].producto.lastIndexOf(" "))
            while(busca){
              const findODPYTD = this.findByMatchingProperties(this.routes, {
                idDestino: origins[0],
                producto: product
              })
              //El arreglo de objetos lo convierte en arreglo de ids de los origenes
              const busquedaYTD = [...new Set(findODPYTD.map(a => a.idOrigen))];
              origins = origins.concat(busquedaYTD)

              //Revisa que algún origen encontrado sea planta y produzca mismo producto
              for(let x= 0; x < busquedaYTD.length; x++){
                if(_.has(this.plants, busquedaYTD[x])){
                  if(this.plantProduct[busquedaYTD[x]+"_"+product] !== undefined){ //Revisa que produzca esa planta ese producto
                    planta = ''+busquedaYTD[x];
                    this.routes[index].planta = planta;
                    this.routes[index].costoProduccion = this.plants[busquedaYTD[x]].costo
                    break;
                  }
                }
              }
              if(planta !== '' || origins.length < 1){
                busca = false
              }
              else{
                origins.shift();
              }
            }
          } */

          


          /*** Termina rescate ***/

          //Llena cadenas de nombres y costos del
          for (let i = originChain.length - 1; i >= 0; i--) {
            if(this.cb[Number(originChain[i])]){
              
              //nombres
              pRoutes[index].cadenaNombres.push(
                this.cb[Number(originChain[i])].idsap+ " "+
                this.cb[Number(originChain[i])].descripcion
              )
              
              if(i < originChain.length - 1){
                
                //costos
                let llave = originChain[i+1] + "_" + originChain[i] + "_" + pRoutes[index].producto
                let llave2 = originChain[i+1] + "_" + originChain[i] + "_" + pRoutes[index].producto.substring(0, pRoutes[index].producto.lastIndexOf(" "))
                
                let producto=''

                let origin = {lat: this.cb[originChain[i+1]].lat*1, lng:this.cb[originChain[i+1]].lng*1}
                let destiny = {lat: this.cb[originChain[i]].lat*1, lng:this.cb[originChain[i]].lng*1}
                if(!(origin.lat==0 || origin.lng==0 || destiny.lat==0 || destiny.lng==0)){
                  pRoutes[index].cadenaDistancias.push(this.haversine_distance(origin,destiny)*1)
                }
                else{
                  pRoutes[index].cadenaDistancias.push(0)
                }

                if(_.has(this.cost, llave)){
                  pRoutes[index].cadenaCosto.push(this.cost[llave])
                  pRoutes[index].cadenaCostoTramo.push(this.costSegment[llave])                  
                  producto = pRoutes[index].producto
                }
                else if(_.has(this.cost, llave2)){
                  pRoutes[index].cadenaCosto.push(this.cost[llave2])
                  pRoutes[index].cadenaCostoTramo.push(this.costSegment[llave2])                  
                  producto = pRoutes[index].producto.substring(0, pRoutes[index].producto.lastIndexOf(" "))
                }
                else{
                  pRoutes[index].cadenaCosto.push(0)
                  pRoutes[index].cadenaCostoTramo.push(0)
                  producto=''
                }

                
                if(producto !== ''){
                  //vehiculos
                  const findVehicle = this.findByMatchingProperties(this.vehicle, {
                    idOrigen:  originChain[i+1],
                    idDestino: originChain[i],
                    producto: producto
                  })
                  
                  const vehiculos = [...new Set(findVehicle.map(a => a.vehiculo))].join('|').trim()
                  
                  pRoutes[index].cadenaVehiculo.push(vehiculos)

                  const transportes = [...new Set(findVehicle.map(a => a.transporte))].join('|').trim()
                  
                  pRoutes[index].cadenaTransporte.push(transportes)

                  //volumen
                  const findVolumen = this.findByMatchingProperties(this.routes, {
                    idOrigen:  originChain[i+1],
                    idDestino: originChain[i],
                    producto: producto
                  })
                  
                  pRoutes[index].cadenaVolumen.push(findVolumen.length>0 ? findVolumen[0].volumen : 0)
                  pRoutes[index].cadenaVolumenTramo.push(findVolumen.length>0 ? findVolumen[0].volumenTramo : 0)

                }
                else{
                  pRoutes[index].cadenaVehiculo.push('SinDetalle')
                  pRoutes[index].cadenaTransporte.push('SinDetalle')
                  pRoutes[index].cadenaVolumen.push(0)
                  pRoutes[index].cadenaVolumenTramo.push(0)
                }
              }
            }
            else{
              pRoutes[index].cadenaNombres.push(originChain[i])
            }
          }

          //Acumula los costos dependiendo del indice
          pRoutes[index].cadenaCostoTramo.forEach((costo,indice) =>{
            if(indice<1){
              pRoutes[index].cadenaAcumCosto.push(Number(costo))
            }
            else{
              pRoutes[index].cadenaAcumCosto.push(Math.round((Number(costo)+ pRoutes[index].cadenaAcumCosto[indice-1])*100)/100)
            }
          })
          
          //Ordena la cadena de indices para que el primero sea el inicio en pta
          pRoutes[index].cadena.reverse()
          pRoutes[index].cadenaProducto.reverse()          

          //Actualiza el número de productos diferentes en ruta
          pRoutes[index].prodDif = [...new Set(pRoutes[index].cadenaProducto)].length

          //Actualiza el número de saltos
          pRoutes[index].saltos = [...new Set(pRoutes[index].cadenaNombres)].length-1
          
          originChain=[];
          productChain=[];
        }
      }
      /* let target_origen = key.split('_')[0]
      let target_producto = key.split('_')[2]
                    
      target_producto = target_producto.replace(/\d{1,2}\.?\d{1,2}k/, '').trim()
      let last_node = target_origen
      for (let key2 in this.routes) {
        let source_origen = key2.split('_')[0]
        let source_destino = key2.split('_')[1]
        let source_producto = key2.split('_')[2]
        source_producto = source_producto.replace(/\d{1,2}\.?\d{1,2}k/, '').trim()
        if (last_node == source_destino && target_producto == source_producto) {
          this.routes[key].unshift([source_origen, source_destino])
          last_node = source_origen
          if (this.plants.indexOf(last_node) >= 0) {
            break
          }
        }
      } */      
    },
    findByMatchingProperties(set, properties) {
      return set.filter(function (entry) {
          return Object.keys(properties).every(function (key) {
              return entry[key] === properties[key];
          });
      });
    },
    findByDestinyProduct(set, properties) {
      return set.filter(function (entry) {
          return entry["idDestino"] === properties["idDestino"] &&
                 ((entry["producto"].lastIndexOf(" ") > 0 ? entry["producto"].substring(0, entry["producto"].lastIndexOf(" ")) : entry["producto"]) === properties["producto"])
      });
    },
    makeResult() {
      let csv = 'Renglón,Origen,Destino,Producto,Cadena,Cadena Nombre,Cadena Costo,Cadena Costo Tramo, Cadena AcumCosto, Planta, Costo Producción, Cadena Producto,ProdDif,Saltos,Cadena Transporte,Cadena Vehiculo, Cadena Volumen,Cadena Volumen Tramo,Cadena Distancias, Distancia, CostoTramoKm, CostoTramo, CostoRuta,Volumen Tramo, Transporte Tramo, Vehiculo Tramo, Origen Nombre, Destino Nombre\n'
      /* for (let key in this.routes) {
        let arr = key.split('_')
        let planta = ''
        if (this.routes[key].length) {
          let id = this.routes[key][0][0]
          if (this.plants.indexOf(id) >= 0) {
            planta = id
          }
        }
        csv += arr[0] + ',' + arr[1] + ',' + arr[2] + ',' + planta + '\n' 
        */
        this.getRoutes.forEach((route,index) =>{
          csv += route.renglon + ',' + 
                 route.idOrigen + ',' +
                 route.idDestino + ',' +
                 route.producto + ',' +
                 route.cadena.join('_') + ',' +
                 route.cadenaNombres.join('_') + ',' +
                 route.cadenaCosto.join('-') + ',' +
                 route.cadenaCostoTramo.join('-') + ',' +
                 route.cadenaAcumCosto.join('_') + ',' +
                 route.planta + ',' +
                 route.costoProduccion + ',' +
                 route.cadenaProducto.join('_') + ',' +
                 route.prodDif + ',' +
                 route.saltos + ',' +
                 route.cadenaTransporte.join('_') + ',' +
                 route.cadenaVehiculo.join('_') + ',' +
                 route.cadenaVolumen.join('_') + ',' +
                 route.cadenaVolumenTramo.join('_') + ',' +
                 route.cadenaDistancias.join('_') + ',' +
                 route.distancia+ ',' +
                 route.costoTramoKm+ ',' +
                 route.costoTramo+ ',' +
                 route.costoRuta+ ',' +
                 route.volumenTramo+ ',' +
                 route.transporteTramo + ',' +
                 route.vehiculoTramo + ',' +
                 route.origenNombre + ',' +
                 route.destinoNombre + ',' +
                  '\n'
        })      
      downloadjs(csv, 'Resultados.csv', 'text/csv')

      csv='Llave,Planta\n'
      Object.keys(this.defaultPlant).forEach(key =>{
        csv+= key+ ',' +
              this.defaultPlant[key]+
              '\n'
      })
      downloadjs(csv, 'PlantaDefault.csv', 'text/csv')

      csv='Centro, Material, Centro Beneficio, plantaB1, costoB1, EsPlanta, plantaB2, costoB2, plantaB3, costoB3, plantaB4, costoB4, PlantaCB, Planta, Costo\n'
      this.sales.forEach(key =>{
        csv+= key.centro + ',' +
              key.material + ',' +
              key.cb + ',' +
              key.plantaB1 + ',' +
              key.costoB1 + ',' +
              key.esPlanta + ',' +
              key.plantaB2 + ',' +
              key.costoB2 + ',' +              
              key.plantaB3 + ',' +
              key.costoB3 + ',' +              
              key.plantaB4 + ',' +
              key.costoB4 + ',' +
              key.plantaCB + ',' +
              key.planta + ',' +
              key.costo + ',' +
              '\n'
      })
      downloadjs(csv, 'ResultadosVentas.csv', 'text/csv')

      this.cancel()
    },
    cancel() {
      this.file = {
        id: [],
        data: null        
      }
    },
    makeResultOptimorum() {
      let csv = '#,KeyId,Origen,Destino,Producto,Volumen,Planta,$Prod,$TnS,$TonE,$Int,$TnM,$APot,$TnMP,$APotP,DesProd,ODPT,Transporte,Saltos\n'
        
        this.getRoutesOptimorum.forEach((route,index) =>{
          csv += route.renglon + ',' + 
                 route.keyId + ',' +
                 (this.cbOptimorum[route.idOrigen]? this.cbOptimorum[route.idOrigen].descripcion:route.idOrigen) + ',' +
                 (this.cbOptimorum[route.idDestino]? this.cbOptimorum[route.idDestino].descripcion:route.idDestino) + ',' +
                 route.producto + ',' +
                 (route.volumenTramo)+ ',' +
                 (route.planta != '' && this.cbOptimorum[route.planta]? this.cbOptimorum[route.planta].descripcion : '')+','+
                 (route.costoProduccion) + ',' +
                 (route.costoTramo) + ',' +
                 (route.costoRuta) + ',' +
                 (route.costoProduccion*1 + route.costoRuta*1) + ',' +
                 route.costoMejor + ',' +
                 route.ahorroPot + ',' +
                 route.costoMejorPlan + ',' +
                 route.ahorroPotPlan + ',' + 
                 route.desProd + ',' +
                 route.odpt + ',' +
                 route.transporteTramo + ',' +
                 route.saltos + ',' +
                 '\n'
        })      
      downloadjs(csv, 'OptimorumPlan.csv', 'text/csv')

      csv = '#,KeyId,Origen,Destino,Producto,Volumen,Planta,$Prod,$TnS,$TonE,$Int,$TnM,$APot,$TnMP,$APotP,DesProd,ODPT,Transporte,Saltos\n'
        
        this.getRoutesOptimorumReal.forEach((route,index) =>{
          csv += route.renglon + ',' + 
                 route.keyId + ',' +
                 (this.cbOptimorum[route.idOrigen]? this.cbOptimorum[route.idOrigen].descripcion:route.idOrigen) + ',' +
                 (this.cbOptimorum[route.idDestino]? this.cbOptimorum[route.idDestino].descripcion:route.idDestino) + ',' +
                 route.producto + ',' +
                 (route.volumenTramo)+ ',' +
                 (route.planta != '' && this.cbOptimorum[route.planta]? this.cbOptimorum[route.planta].descripcion : '')+','+
                 (route.costoProduccion) + ',' +
                 (route.costoTramo) + ',' +
                 (route.costoRuta) + ',' +
                 (route.costoProduccion*1 + route.costoRuta*1) + ',' +
                 route.costoMejor + ',' +
                 route.ahorroPot + ',' +
                 route.costoMejorPlan + ',' +
                 route.ahorroPotPlan + ',' +
                 route.desProd + ',' +
                 route.odpt + ',' +
                 route.transporteTramo + ',' +
                 route.saltos + ',' +
                  '\n'
        })      
      downloadjs(csv, 'OptimorumReal.csv', 'text/csv')

      this.cancel()
    },
    makeResultNoCostSegment() {
      let csv = '#,Origen,Destino,Producto,Transporte,Escenario\n'
        
        this.noCostSegments.forEach((route,index) =>{
          csv += (index+1) + ',' + 
                 route.origen + ',' +
                 route.destino + ',' +
                 route.producto + ',' +
                 route.transporte + ',' +
                 route.scenario + ',' +
                 '\n'
        })      
      downloadjs(csv, 'SegmentosSinCosto.csv', 'text/csv')
      this.cancel()
    },
    makeResultDesProdDetalle() {
      let csv = '#,DesProd,Destino,Producto,TnsP,TnsR,Var,Var%\n'
        
        this.desProdDetalle.forEach((route,index) =>{
          csv += (index+1) + ',' +                  
                 route.desProd + ',' +
                 route.destino + ',' +
                 route.producto + ',' +
                 route["planeado"].volumen + ',' +
                 route["real"].volumen + ',' +
                 Math.abs(route["planeado"].volumen - route["real"].volumen) + ',' +
                 route.variacion + ',' +                 
                 '\n'
        })      
      downloadjs(csv, 'listadoDesProdVolumen.csv', 'text/csv')
      this.cancel()
    },
    exportCosts() {
      let csv='Llave,CostoTonVta,CostoTonTramo\n'
      let tempODP = this.abastoMeses[this.mesActual.value].oDP
      Object.keys(tempODP).forEach(key =>{
        csv+= key+ ',' +
              tempODP[key].costoVta+ ',' +
              tempODP[key].costoTramo+
              '\n'
      })
      downloadjs(csv, 'cat_costoMes '+this.mesActual.text+'.csv', 'text/csv')

      this.cancel()
    },
    exportCostsVehicle() {
      let csv='Origen#,Destino#,DescrProducto,Transporte,Vehiculo,AbastecidasDestino,Flete,AbastoParaVenta,FleteEncadenado\n'
      let fields = []
      let tempODPTV = this.abastoMeses[this.mesActual.value].oDPTV
      Object.keys(tempODPTV).forEach(key =>{
        fields = key.split('_')
        csv+= fields[0]+ ',' +
              fields[1]+ ',' +
              fields[2]+ ',' +
              fields[3]+ ',' +
              fields[4]+ ',' +
              tempODPTV[key].volTramo+ ',' +
              tempODPTV[key].fleteTramo+ ',' +
              tempODPTV[key].volVta+ ',' +
              tempODPTV[key].fleteVta+ ',' +
              '\n'
      })
      downloadjs(csv, 'cat_vehiculo '+this.mesActual.text+'.csv', 'text/csv')

      this.cancel()
    },
    exportYTDRoutes() {
      let csv='Origen#,Destino#,DescrProducto,Transporte,Vehiculo,volTramo,$TonTramo,volVta,$TonVta\n'
      let fields = []
      let tempODPTV = this.abastoMesesAcum.oDPTV
      Object.keys(tempODPTV).forEach(key =>{
        fields = key.split('_')
        csv+= fields[0]+ ',' +
              fields[1]+ ',' +
              fields[2]+ ',' +
              fields[3]+ ',' +
              fields[4]+ ',' +
              tempODPTV[key].volTramo+ ',' +
              tempODPTV[key].costoTramo+ ',' +
              tempODPTV[key].volVta+ ',' +
              tempODPTV[key].costoVta+ ',' +
              '\n'
      })
      downloadjs(csv, 'ytd_rutas '+this.mesActual.text+'.csv', 'text/csv')

      this.cancel()
    },
    exportRelation() {
      let csv='Origen#,Destino#,DescrProducto,VolVta,VolTramo\n'
      let fields = []
      let tempODP = this.abastoMeses[this.mesActual.value].oDP
      Object.keys(tempODP).forEach(key =>{
        fields = key.split('_')
        csv+= fields[0]+ ',' +
              fields[1]+ ',' +
              fields[2]+ ',' +
              tempODP[key].volVta+ ',' +
              tempODP[key].volTramo+ ',' +
              '\n'
      })
      downloadjs(csv, 'relation '+this.mesActual.text+'.csv', 'text/csv')

      this.cancel()
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight - 160;
    }
  },  
  computed:{
    getSummaryOptimorumReal(){
      let summary = { cantidad:0, volumen:0, volumenRuta:0, costoTnSeg:0, costoTn:0, ahorroPot:0, ahorroPotPlan:0}
      let rutas = [... this.getRoutesOptimorumReal]
      let fleteVisible = 0
      let fleteVisibleRuta = 0
      let produccion = 0
      let produccionRuta = 0

      summary.cantidad = rutas.length
      rutas.forEach((item,index) =>{        
        summary.volumen += (item.volumenTramo*1)
        summary.volumenRuta += (item.volumen*1)        
        fleteVisible += (item.costoTramo * item.volumenTramo)
        fleteVisibleRuta += (item.costoRuta * item.volumen)
        produccion +=(item.costoProduccion * item.volumenTramo) 
        produccionRuta += (item.costoProduccion * item.volumen)
        summary.ahorroPot += item.interfacility_chain.toLowerCase().indexOf("recogido") === -1? item.ahorroPot : 0
        summary.ahorroPotPlan += item.interfacility_chain.toLowerCase().indexOf("recogido") === -1? item.ahorroPotPlan : 0
      })
      summary.costoTnSeg = fleteVisible / summary.volumen
      summary.costoTn = fleteVisibleRuta / summary.volumenRuta
      summary.costoTnProdSeg = produccion / summary.volumen
      summary.costoTnProd = produccionRuta / summary.volumenRuta
      summary.integral = (produccionRuta + fleteVisibleRuta) / summary.volumenRuta

      return summary
    },
    getSummaryOptimorum(){
      let summary = { cantidad:0, volumen:0, volumenRuta:0, costoTnSeg:0, costoTn:0, ahorroPot:0, ahorroPotPlan:0}
      let rutas = [... this.getRoutesOptimorum]
      let fleteVisible = 0
      let fleteVisibleRuta = 0
      let produccion = 0
      let produccionRuta = 0

      summary.cantidad = rutas.length
      rutas.forEach((item,index) =>{        
        summary.volumen += (item.volumenTramo*1)
        summary.volumenRuta += (item.volumen*1)        
        fleteVisible += (item.costoTramo * item.volumenTramo)
        fleteVisibleRuta += (item.costoRuta * item.volumen)
        produccion +=(item.costoProduccion * item.volumenTramo) 
        produccionRuta += (item.costoProduccion * item.volumen)
        /* summary.ahorroPot += item.interfacility_chain.slice(-11) != '[Recogido]|'? item.ahorroPot:0
        summary.ahorroPotPlan += item.interfacility_chain.slice(-11) != '[Recogido]|'? item.ahorroPotPlan:0 */
        summary.ahorroPot += item.interfacility_chain.toLowerCase().indexOf("recogido") === -1? item.ahorroPot : 0
        summary.ahorroPotPlan += item.interfacility_chain.toLowerCase().indexOf("recogido") === -1? item.ahorroPotPlan : 0
      })
      summary.costoTnSeg = fleteVisible / summary.volumen
      summary.costoTn = fleteVisibleRuta / summary.volumenRuta
      summary.costoTnProdSeg = produccion / summary.volumen
      summary.costoTnProd = produccionRuta / summary.volumenRuta
      summary.integral = (produccionRuta + fleteVisibleRuta) / summary.volumenRuta

      return summary
    },
    getSummary(){
      let summary = { cantidad:0, volumen:0, volumenRuta:0, costoTnSeg:0, costoTn:0}
      let rutas = [... this.getRoutes]
      let fleteVisible = 0
      let fleteVisibleRuta = 0
      let produccion = 0
      let produccionRuta = 0

      summary.cantidad = rutas.length
      rutas.forEach((item,index) =>{        
        summary.volumen += (item.volumenTramo*1)
        summary.volumenRuta += (item.volumen*1)
        fleteVisible += (item.costoTramo * item.volumenTramo)        
        fleteVisibleRuta += (item.costoRuta * item.volumen)
        produccion +=(item.costoProduccion * item.volumenTramo) 
        produccionRuta += (item.costoProduccion * item.volumen)
      })
      summary.costoTnSeg = fleteVisible / summary.volumen
      summary.costoTn = fleteVisibleRuta / summary.volumenRuta
      summary.costoTnProd = produccion / summary.volumen
      summary.costoTnSeg = produccionRuta / summary.volumenRuta
      return summary
    },
    getRoutesOptimorumReal(){
      if(this.routesOptimorumReal){
        let result = this.routesOptimorumReal;
        if(this.idOrigenOptimorum){
          let origenes = this.idOrigenOptimorum.map(a =>a.value.toString().toLocaleUpperCase())
          if(origenes.length>0){
            //result = result.filter((ruta) => ruta.idOrigen === this.idOrigen.value )
            result = result.filter((ruta) => origenes.includes(ruta.idOrigen) )
          }
        }
        if(this.idDestinoOptimorum){
          let destinos = this.idDestinoOptimorum.map(a =>a.value.toString().toLocaleUpperCase())
          if(destinos.length>0){
            //result = result.filter((ruta) => ruta.idDestino === this.idDestino.value )
            result = result.filter((ruta) => destinos.includes(ruta.idDestino) )
          }
        }        
        if(this.productoOptimorum){
          let productos = this.productoOptimorum.map(a =>a.value.toString().toLocaleUpperCase())
          if(productos.length>0){
            result = result.filter((ruta) => productos.includes(ruta.producto.toString().toLocaleUpperCase()) )
          }
        }
        if(this.saltosOptimorum){
          result = result.filter((ruta) => ruta.saltos.toString() === this.saltosOptimorum )
        }
        if(this.idPlantaProdOptimorum){
          let plantas = this.idPlantaProdOptimorum.map(a =>a.value.toString().toLocaleUpperCase())
          if(plantas.length>0){
            result = result.filter((ruta) => plantas.includes(ruta.planta) )
          }
        } 
        if(this.transportesFiltroOptimorum){
          let transportes = this.transportesFiltroOptimorum.map(a =>a.value.toString())
          if(transportes.length > 0){            
            result = result.filter((ruta) => transportes.sort().join(',') === ruta.cadenaTransporte[ruta.cadenaTransporte.length-1].split('|').sort().join(','))
          }
        }
        if(this.costoCalculadoOptimorum){
          let estatus = this.costoCalculadoOptimorum.map(a =>a.value.toString())
          if(estatus.length > 0){            
            result = result.filter((ruta) => estatus == ruta.bCostoCalculado)
          }
        }
        if(this.costoOptimorum){
          result = result.filter((ruta) => this.numberWithCommasND(ruta.costoTramo.toString()) === this.numberWithCommasND(this.costoOptimorum) || this.numberWithCommasND(ruta.costoRuta.toString()) === this.numberWithCommasND(this.costoOptimorum) )
        }
        if(this.desProdOptimorum){
          result = result.filter((ruta) => this.numberWithCommasND(ruta.desProd.toString()) === this.numberWithCommasND(this.desProdOptimorum))
        }
        if(this.odptOptimorum){
          result = result.filter((ruta) => this.numberWithCommasND(ruta.odpt.toString()) === this.numberWithCommasND(this.odptOptimorum))
        }

        if(result.length>0){
          /* if(this.sortColumnOptimorumReal.indexOf("costoTotal")> -1){
            let tempCostoTotal=[]
            result.forEach(element =>{
              element["costoTotal"] = element.costoProduccion*1 + element.costoRuta*1
              tempCostoTotal.push(element)
            })
            result = [...tempCostoTotal]
          } */
          
          result.sort((a,b) =>{
            if (!isNaN(parseFloat(a[this.sortColumnOptimorumReal])) && !isNaN(parseFloat(b[this.sortColumnOptimorumReal]))){
              return this.sortDirectionOptimorumReal ? b[this.sortColumnOptimorumReal] - a[this.sortColumnOptimorumReal] : a[this.sortColumnOptimorumReal] - b[this.sortColumnOptimorumReal] ;
            }
            else{
              if ( a[this.sortColumnOptimorumReal] < b[this.sortColumnOptimorumReal] ) return this.sortDirectionOptimorumReal? -1 : 1;
              if ( a[this.sortColumnOptimorumReal] > b[this.sortColumnOptimorumReal] ) return this.sortDirectionOptimorumReal? 1 : -1;
              return 0;
            }
          });
          
        }

        return result
      }
      else {
        return []
      }
    },
    getRoutesOptimorum(){
      if(this.routesOptimorum){
        let result = this.routesOptimorum;
        if(this.idOrigenOptimorum){
          let origenes = this.idOrigenOptimorum.map(a =>a.value.toString().toLocaleUpperCase())
          if(origenes.length>0){
            //result = result.filter((ruta) => ruta.idOrigen === this.idOrigen.value )
            result = result.filter((ruta) => origenes.includes(ruta.idOrigen) )
          }
        }
        if(this.idDestinoOptimorum){
          let destinos = this.idDestinoOptimorum.map(a =>a.value.toString().toLocaleUpperCase())
          if(destinos.length>0){
            //result = result.filter((ruta) => ruta.idDestino === this.idDestino.value )
            result = result.filter((ruta) => destinos.includes(ruta.idDestino) )
          }
        }        
        if(this.productoOptimorum){
          let productos = this.productoOptimorum.map(a =>a.value.toString().toLocaleUpperCase())
          if(productos.length>0){
            result = result.filter((ruta) => productos.includes(ruta.producto.toString().toLocaleUpperCase()) )
          }
        }
        if(this.saltosOptimorum){
          result = result.filter((ruta) => ruta.saltos.toString() === this.saltosOptimorum )
        }
        if(this.idPlantaProdOptimorum){
          let plantas = this.idPlantaProdOptimorum.map(a =>a.value.toString().toLocaleUpperCase())
          if(plantas.length>0){
            result = result.filter((ruta) => plantas.includes(ruta.planta) )
          }
        } 
        if(this.transportesFiltroOptimorum){
          let transportes = this.transportesFiltroOptimorum.map(a =>a.value.toString())
          if(transportes.length > 0){ 
            result = result.filter((ruta) => transportes.sort().join(',') === ruta.cadenaTransporte[ruta.cadenaTransporte.length-1].split('|').sort().join(','))
          }
        }
        if(this.costoCalculadoOptimorum){
          let estatus = this.costoCalculadoOptimorum.map(a =>a.value.toString())
          if(estatus.length > 0){            
            result = result.filter((ruta) => estatus == ruta.bCostoCalculado)
          }
        }
        if(this.costoOptimorum){
          result = result.filter((ruta) => this.numberWithCommasND(ruta.costoTramo.toString()) === this.numberWithCommasND(this.costoOptimorum) || this.numberWithCommasND(ruta.costoRuta.toString()) === this.numberWithCommasND(this.costoOptimorum) )
        }
        if(this.desProdOptimorum){
          result = result.filter((ruta) => this.numberWithCommasND(ruta.desProd.toString()) === this.numberWithCommasND(this.desProdOptimorum))
        }
        if(this.odptOptimorum){
          result = result.filter((ruta) => this.numberWithCommasND(ruta.odpt.toString()) === this.numberWithCommasND(this.odptOptimorum))
        }
        if(result.length>0){
          /* if(this.sortColumnOptimorum.indexOf("costoTotal")> -1){
            let tempCostoTotal=[]
            result.forEach(element =>{
              element["costoTotal"] = element.costoProduccion*1 + element.costoRuta*1
              tempCostoTotal.push(element)
            })
            result = [...tempCostoTotal]
          } */
          
          result.sort((a,b) =>{
            if (!isNaN(parseFloat(a[this.sortColumnOptimorum])) && !isNaN(parseFloat(b[this.sortColumnOptimorum]))){
              return this.sortDirectionOptimorum ? b[this.sortColumnOptimorum] - a[this.sortColumnOptimorum] : a[this.sortColumnOptimorum] - b[this.sortColumnOptimorum] ;
            }
            else{
              if ( a[this.sortColumnOptimorum] < b[this.sortColumnOptimorum] ) return this.sortDirectionOptimorum? -1 : 1;
              if ( a[this.sortColumnOptimorum] > b[this.sortColumnOptimorum] ) return this.sortDirectionOptimorum? 1 : -1;
              return 0;
            }
          });
          
        }

        return result
      }
      else {
        return []
      }
    },
    getRoutes: function () {
      if(this.routes){
        let result = this.routes;
        if(this.idOrigen){
          let origenes = this.idOrigen.map(a =>a.value.toString().toLocaleUpperCase())
          if(origenes.length>0){
            //result = result.filter((ruta) => ruta.idOrigen === this.idOrigen.value )
            result = result.filter((ruta) => origenes.includes(ruta.idOrigen) )
          }
        }
        if(this.idDestino){
          let destinos = this.idDestino.map(a =>a.value.toString().toLocaleUpperCase())
          if(destinos.length>0){
            //result = result.filter((ruta) => ruta.idDestino === this.idDestino.value )
            result = result.filter((ruta) => destinos.includes(ruta.idDestino) )
          }
        }        
        if(this.producto){          
          let productos = this.producto.map(a =>a.value.toString().toLocaleUpperCase())
          if(productos.length>0){
            result = result.filter((ruta) => productos.includes(ruta.producto.toString().toLocaleUpperCase()) )
          }
        }
        if(this.saltos){
          result = result.filter((ruta) => ruta.saltos.toString() === this.saltos )
        }
        if(this.idPlantaProd){
          let plantas = this.idPlantaProd.map(a =>a.value.toString().toLocaleUpperCase())
          if(plantas.length>0){
            result = result.filter((ruta) => plantas.includes(ruta.planta) )
          }
        } 
        /* if(this.range){
          result = result.filter((ruta) => ruta.costoTramo >= this.range[0] && ruta.costoTramo <= this.range[1])
        }
        if(this.rangeVol){
          result = result.filter((ruta) => ruta.volumen >= this.rangeVol[0] && ruta.volumen <= this.rangeVol[1])
        }
        if(this.rangeTonKm){
          result = result.filter((ruta) => ruta.costoTramoKm >= this.rangeTonKm[0] && ruta.costoTramoKm <= this.rangeTonKm[1])
        }*/
        if(this.transportesFiltro){
          let transportes = this.transportesFiltro.map(a =>a.value.toString())
          if(transportes.length > 0){            
            result = result.filter((ruta) => transportes.sort().join(',') === ruta.cadenaTransporte[ruta.cadenaTransporte.length-1].split('|').sort().join(','))
          }
        }
        
        
        if(result.length>0){
          if(this.sortColumn.indexOf("costoTotal")> -1){
            let tempCostoTotal=[]
            result.forEach(element =>{
              element["costoTotal"] = element.costoProduccion*1 + element.costoRuta*1
              tempCostoTotal.push(element)
            })
            result = [...tempCostoTotal]
          }
          
          result.sort((a,b) =>{
            if (!isNaN(parseFloat(a[this.sortColumn])) && !isNaN(parseFloat(b[this.sortColumn]))){
              return this.sortDirection ? b[this.sortColumn] - a[this.sortColumn] : a[this.sortColumn] - b[this.sortColumn] ;
            }
            else{
              if ( a[this.sortColumn] < b[this.sortColumn] ) return this.sortDirection? -1 : 1;
              if ( a[this.sortColumn] > b[this.sortColumn] ) return this.sortDirection? 1 : -1;
              return 0;
            }
          });
          
        }

        return result
      }
      else {
        return []
      }
    },    
  }
}
</script>

<style scoped lang="scss">
/* tr:nth-child(odd)   { background-color: #eee; }
tr:nth-child(even)    { background-color:#fff; } */

/* .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) { 
  background: #B1B8BF;
  color: white;
}

.v-data-table::v-deep th {
  font-size: 0.9rem !important;
  font-weight: 700;
}
.v-data-table::v-deep td {
  font-size: 0.85rem !important;
  font-weight: 400;  
}*/

.flexcard {
  display: flex;
  flex-direction: column;
  background-color: #c0c0c0;
}
// Add the css below if your card has a toolbar, and if your toolbar's height increases according to the flex display.
.flexcard .v-toolbar {
  flex: 0;
}

.selected{
  background-color: limegreen;
}

p:not([class]) {
  max-width: 50ch;
}

.box {
  width: 100%;
  border-radius: 5px;
  align-content: center;
}

.subtitle {
  margin: 1rem;
}

.planta {
  background-color: #F02230;
  color: white;      
}

.bodega {
  background-color: #0000B4;
  color: white;
}

.tramo {
  background-color: #eee;
  color: hsl(var("--clr-light"));
  font-weight: 600;
}

.btn__mode {
  position:absolute;
  top: 17px;
  right: 20px;
  z-index: 2;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.btn__mode__half {
  position:absolute;
  top: 17px;
  right: 40px;
  z-index: 2;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.btn__kpi {
  width:100%;
  height:30px;
  background-color:#0000B4;
  margin: 0.5rem 0.30rem 0 0.30rem;
  color: #fff;
  align-content:center;
}

.title__resumen{
  border-bottom: 1px solid #E0E0E0;
  font-size: 0.9rem;
  font-weight: 700;  
}

.footer-line {
  width: 100%;
  align-content: center;
  background-color: #eee;
  font-size:0.9rem;
  
}
.footer-end{
  border-radius: 0 0 10px 10px;
}

.alertBox{  
  max-height: 250px;
  max-width: 330px;
  position: absolute;
  bottom: 5px;
  right: 15px;
  border-radius: 5px;
  color: #fff;
  padding: 5px;
  margin-left: 15px;
  text-align: left;
}

.green {
  background-color: #F02230;
}

.red {
  background-color: #900;
}

.calculated {
  //other things here
  /* &:before{
    content: "*";
  } */
  text-decoration: underline;
}

.fade-in {
	opacity: 1;
	animation-name: fadeInOpacity;
	animation-iteration-count: 1;
	animation-timing-function: ease-in;
	animation-duration: 0.5s;
}

@keyframes fadeInOpacity {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

table {
  text-align: left;
  position: relative;
  border-collapse: collapse;
  min-width: 100%;
  background-color: #fff;
}
th, td {
  padding: 0.25rem;
  text-align: center;
  white-space: nowrap;
  color: #000;
  /* max-width: 120px; */
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid #eee;
}
tr th {
  background: white;
  color: black;
}
th {
  background: white;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}
.titleTablesOp {  
  color: #000;
  font-weight: 600;
  text-align: left;
  width:100%;
}
</style>
<style>
body {
  overscroll-behavior-y: contain;
}
</style>
